export default {
  general: {
    login: 'Connexion',
    password: 'Mot de passe',
    email: 'Courrier électronique',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    name: 'Nom',
    address: 'Adresse',
    zip: 'code postal',
    city: 'lieu',
    phone: 'téléphone',
    birthdate: 'Date de naissance',
    ok: 'Ok',
    cancel: 'Annuler',
    save: 'Sauvegarder',
    swisspass: 'SwissPass',
    skicard: 'KeyCard',
    printAtHome: 'Print@Home',
    user: 'Utilisateur',
    delete: 'supprimer',
    next: 'suivant',
    back: 'Retour',
    select: 'Sélectionner',
    skiticket: 'Forfait de ski',
    overview: 'Aperçu',
    I: 'moi',
    date: 'date',
    here: 'ici',
    options: 'Options',
    option: 'Option',
    loadMore: 'En savoir plus',
    ticket: 'Billet',
    category: 'Catégorie',
    from: 'De',
    rowsPerPage: 'Lignes par page',
    to: 'à',
    loadingData: 'chargement des données',
    close: 'Fermer',
    price: 'Prix',
    country: 'Pays',
    today: 'Aujourd\'hui',
    days: 'Jours',
    day: 'Jour',
    print: 'Imprimer',
    apply: 'Postuler',
    toCart: 'Vers le panier d\'achats'
  },
  layout: {
    register: 'Enregistrer',
    booking: 'réservation en ligne',
    selectLanguage: 'Langue',
    selectLanguageModalHeader: 'Sélectionnez une langue',
    userAccount: 'Compte d\'utilisateur',
    logout: 'Déconnexion',
    menu: 'Menu',
    apply: 'Connexion',
    helpAndFaq: 'Aide et FAQ',
    contact: 'Contact',
    customerManagement: 'gestion clients',
    dashboard: 'tableaux de bord',
    agb: 'Conditions générales et conditions d\'utilisation',
    myCards: 'Mes supports de données'
  },
  registration: {
    firstName: 'Prénom *',
    lastName: 'Nom de famille *',
    email: 'E-mail *',
    password: 'Mot de passe',
    passwordRepete: 'Répéter le mot de passe *',
    acceptAgb: 'J\'accepte la réglementation sur la protection des données et j\'accepte les AGB *',
    acceptDataPrivacy: 'J\'accepte la politique de protection de la vie privée *',
    youHaveToAcceptAgb: 'Veuillez accepter l\'AGB et la politique de confidentialité',
    youHaveToAcceptDataPrivacy: 'Veuillez accepter la politique de confidentialité',
    registrationTitle: 'Créer un compte utilisateur',
    register: 'S\'inscrire',
    eMailRequired: 'Veuillez saisir l\'adresse email',
    isNotEmail: 'Ceci n\'est pas une adresse email valide',
    passwordWrong: 'Mot de passe incorrect',
    passwordRequired: 'Veuillez saisir votre mot de passe',
    passwordConstraints: 'Spécifications pour le mot de passe',
    passwordIsNotUid: 'Le mot de passe ne doit pas contenir un e-mail, un prénom ou un nom.',
    passwordHasLetters: 'Le mot de passe doit contenir des majuscules et des minuscules.',
    passwordHasCapitalLetter: 'Le mot de passe doit contenir au moins une majuscule.',
    passwordHasSpecialCharacter: 'Le mot de passe doit contenir au moins un caractère spécial.',
    passwordHasNumber: 'Le mot de passe doit contenir au moins un chiffre.',
    passwordEqual: 'Les mots de passe doivent correspondre.',
    passwordLength: 'Le mot de passe doit comporter au moins 8 caractères.',
    alreadyAccount: 'Vous avez déjà un compte ? Cliquez ici.',
    firstNameRequired: 'Veuillez saisir votre prénom',
    lastNameRequired: 'Veuillez saisir votre nom de famille',
    checkInput: 'vérifier',
    street: 'rue',
    streetStar: 'rue *',
    zip: 'code postal *',
    city: 'Lieu',
    cityStar: 'Lieu *',
    cityRequired: 'Veuillez indiquer le lieu de résidence',
    country: 'Pays',
    zipRequired: 'Veuillez entrer le code postal',
    addressRequired: 'Veuillez entrer votre adresse',
    phone: 'téléphone',
    phoneStar: 'téléphone *',
    phoneRequired: 'Veuillez entrer votre numéro de téléphone.',
    companyRequired: 'Veuillez saisir l\'entreprise',
    companyStar: 'Entreprise *',
    company: 'Entreprise'
  },
  login: {
    loginHeadline: 'Connexion',
    checkMail: 'Vérifier l\' e-mail',
    passwordRequired: 'Vous devez entrer un mot de passe',
    saveCookie: 'enregistrer le cookie',
    onlyOnPersonalComputer: 'Seulement sur PC',
    forgetPw: 'mot de passe oublié?',
    passwordSentExplanation: 'Nous venons de vous envoyer un e-mail avec des informations complémentaires. Vous pouvez l\'utiliser pour vous connecter.',
    passwordSentInfo: 'Vous vous demandez pourquoi nous vous envoyons un nouveau mot de passe ? L\'un de nos collaborateurs a fait une erreur dans la ' + 'a pris en charge une réservation en votre nom et a créé un compte dans ce cadre. ' + 'Nous souhaitons ainsi vous offrir le plus grand confort possible et accélérer votre inscription. Avec le mot de passe que nous venons de vous envoyer, ' + 'vous pouvez maintenant vous connecter à votre compte.',
    acceptAgbsButton: 'Accepter les conditions générales',
    acceptAgbs: 'Veuillez confirmer nos conditions générales',
    errorWhileDataTransfer: 'Une erreur est survenue lors du transfert de vos données. Veuillez réessayer.'
  },
  spinner: {
    pleaseWait: 'Un moment, s\'il vous plaît',
    tryToLogin: 'Nous essayons de vous connecter automatiquement.'
  },
  notify: {
    errorDeleteCapacity: 'erreur lors de la suppression.',
    errorUpdateCapacity: 'La mise à jour n\'a pas pu être sauvegardée.',
    userSuccessfullyRegistered: 'Merci beaucoup pour votre inscription.',
    registrationFailed: 'échec de l\'enregistrement.Veuillez réessayer plus tard.',
    standardError: 'Une erreur s\'est produite. Veuillez réessayer plus tard.',
    passwordWasSent: 'Vous avez reçu un e-mail avec votre mot de passe.',
    emailDoesNotExist: 'L\'e-mail n\'existe pas. Vous devez d\'abord vous inscrire.',
    loginSuccess: 'Connexion réussie!',
    loginError: 'Une erreur s\'est produite lors de la connexion.',
    logoutSuccess: 'Déconnexion réussie!',
    autologinFailed: 'Malheureusement, nous n\'avons pas pu vous connecter automatiquement',
    languageChangedSuccessfully: 'Nouvelle langue enregistrée dans votre profil avec succès.',
    languageCouldNotBeSaved: 'Nouvelle langue n\'a pu être enregistré dans votre profil.',
    profileInfoSaved: 'Informations de votre profil sauvegardées. Merci beaucoup!',
    mailNotSaved: 'Malheureusement, nous n\'avons pas pu enregistrer l\'e-mail.',
    mailsHaveToBeEquals: 'Les e-mails ne correspondent pas.',
    passwordChangedSuccessfully: 'Le mot de passe a été modifié avec succès.',
    pwResetCodeSentToMail: 'Nous vous avons envoyé un e-mail avec un code. Copiez-le dans la case ci-dessous.',
    wrongCodeSent: 'Vous avez saisi un code erroné. Veuillez réessayer.',
    passwordResetSuccessfull: 'Vous avez réussi à réinitialiser le mot de passe.',
    clickedDayHasToBeLinked: 'Vous ne pouvez sélectionner que des jours consécutifs.',
    maxReservationTimeLimitReached: 'Malheureusement, vous ne pouvez pas réserver plus de jours consécutifs.',
    dayIsInPast: 'La date est hors saison',
    selectDay: 'Veuillez choisir un jour',
    fullFillForm: 'Veuillez remplir tous les cases obligatoires',
    voucherIsInvalid: 'Le bon n\'est pas valable:',
    maxDayLimitExeeded: 'Vous pouvez réserver un maximum de {maxSelectedDays} jours affilée.',
    loadingWeatherFailed: 'Les données météorologiques n\'ont pas pu être chargées',
    updatingWeatherFailed: 'La prévision n\'a pas pu être ajustée',
    errorWhileFetchingCapacities: 'Les capacités n\'ont pas pu être chargées.',
    errorCreatingNewCapacity: 'La capacité n\'a pas pu être créée.'
  },
  profile: {
    personalInformation: 'Informations personnelles',
    birthday: 'Anniversaire *',
    changeMailModalHeader: 'Changer d\'e-mail',
    newMailFirst: 'Nouvel e-mail *',
    newMailRepeat: 'Répéter le nouvel e-mail *',
    perfectSkiDay: 'Décrivez votre journée de ski idéale',
    optionalDataHeaderText: 'Options facultatives',
    favoriteSkiRessort: 'Mon domaine skiable préféré',
    favoriteSkiMask: 'Ma marque de ski préférée',
    education: 'Formation',
    profession: 'Profession',
    changePassword: 'Changer de mot de passe',
    changePasswordModalTitle: 'Changer de mot de passe',
    myCards: 'Mes supports de données',
    cardType: 'Type de carte',
    cardNumber: 'Numéro de carte',
    deactivateProfile: 'Désactiver le profil',
    reallyDeactivateProfile: 'Vous voulez vraiment désactiver votre profil?',
    reallyDeleteText: 'Si vous désactivez votre profil, nous supprimerons votre adresse électronique stockée. ' + '<b> Vous ne pourrez plus utiliser le compte. Votre compte sera désactivé !',
    yourName: 'Votre nom',
    doesNotMatchWithYourName: 'L\'entrée ne correspond pas à votre nom.',
    enterYourNameForSecurityReasons: 'Entrez votre prénom dans le champ pour des raisons de sécurité.'
  },
  rule: {
    inputRequired: 'L\'entrée est obligatoire',
    firstName: 'Veuillez saisir le prénom',
    lastName: 'Veuillez entrer le nom de famille',
    birthdate: 'Veuillez indiquer la date de naissance',
    selectCard: 'Veuillez sélectionner une carte',
    selectUser: 'Sélectionner un utilisateur',
    selectDataMedium: 'Veuillez choisir un support de données',
    addVoucher: 'Veuillez entrer un code de bon valide'
  },
  resetPw: {
    resetPwButton: 'réinitialiser le mot de passe',
    explanation: 'Saisissez l\'e-mail associé à votre compte. Nous vous enverrons un code avec lequel vous pourrez réinitialiser votre mot de passe.',
    headline: 'Réinitialiser votre mot de passe',
    codeRequired: 'Nous vous avons envoyé un code par e-mail. Copiez-le dans la case ci-dessous.',
    resetCode: 'Saisissez ici le code que vous avez reçu par e-mail',
    newPw: 'Nouveau mot de passe *',
    newPwRepeat: 'Répéter le nouveau mot de passe *',
    userNotFound: 'Cet e-mail n\'est pas enregistré chez nous'
  },
  myProfiles: {
    newProfile: 'Ajouter des utilisateurs',
    birthday: 'anniversaire *',
    birthdayRequried: 'Veuillez renseigner votre anniversaire',
    profilesNotLoaded: 'Les profils n\'ont pas pu être chargés',
    userDeleted: 'Nous avons supprimé l\'utilisateur',
    userNotDeleted: 'Malheureusement, nous n\'avons pas pu supprimer l\'utilisateur',
    reallyDelete: 'Souhaitez vous vraiment supprimer l\'utilisateur?'
  },
  cardAdder: {
    addCard: '+',
    cardNumber: 'Numéro de carte',
    cardNumberRequired: 'Merci de renseigner votre numéro de carte',
    waitingForCamera: 'On charge la caméra. Un petit moment, s\'il vous plaît. Veuillez vérifier les paramètres de votre navigateur si ' + 'la caméra ne peut pas être chargée en quelques secondes.',
    zipRequired: 'Merci de renseigner votre code postal.',
    cardDescription: 'Nommer la carte',
    acceptSwisspassAgb: 'Veuillez accepter les conditions générales de vente SwissPass.',
    swisspassAgb: 'J\'accepte les conditions générales de vente SwissPass',
    smartCard: 'Axess KeyCard',
    captureSmartCard: 'Saisir une KeyCard Axess',
    smartCardInputExplanation: 'En principe, vous pouvez utiliser n\'importe quelle KeyCard d\'Axess ' + '(également d\'un autre domaine skiable). Pour ce faire, indiquez dans le champ "numéro de carte" le numéro ' + 'au dos de votre KeyCard. La saisie se fait <u>avec un trait d\'union.</u>'
  },
  addNewProfile: {
    newProfileAddedSuccessfully: 'Nouveau profil ajouté avec succès',
    birthdayRequired: 'Merci de renseigner votre date d\'anniversaire.',
    newCardModalTitle: 'Ajouter une carte',
    cardAdded: 'La carte a été ajoutée',
    invalidSkicardNumber: 'Le numéro de carte est invalide.',
    invalidSwisspassNumber: 'Le numéro de carte est incorrect. Saisissez votre numéro de carte à 11 chiffres dans le champ "Numéro de carte". ' + 'numéro de SwissPass, S inclus, mais sans tirets. Vous trouverez ce numéro au verso ' + ' sans tirets dans le champ «Numéro de carte». Vous pouvez trouver le numéro au dos de votre SwissPass.',
    cards: 'Cartes',
    cardDelted: 'Nous avons supprimé la carte',
    userUpdated: 'Nous avons mis à jour l\'utilisateur',
    mailAlreadyExists: 'Cet e-mail existe déjà. Veuillez en utiliser un autre.',
    wrongBirthdayFormat: 'Veuillez saisir la date de naissance au format JJ.MM.AAAA.',
    userLinkedToRegion: 'La personne a été ajoutée. Veuillez maintenant ajouter le client via le champ de recherche.'
  },
  booking: {
    selectDate: 'Sélectionner la date',
    selectPerson: 'Sélectionner les personnes',
    timeLeft: 'Temps de réservation restant',
    cashPaymentFailed: 'Le paiement n\'a pas pu être enregistré!',
    cashPaymentSuccessful: 'Paiement effectué avec succés',
    noteCouldNotBeSaved: 'La remarque n\'a pas pu être enregistrée.',
    noteSaved: 'La remarque a été enregistrée.',
    unexpectedAmount: 'ATTENTION : Le montant encaissé ne correspond pas au montant du calcul du prix ! ' + 'Veuillez informer immédiatement le support de Pricenow avec les informations suivantes : ID de réservation : {bookingId} / Montant attendu : {expectedAmount}',
    bookingChanged: 'Les modifications apportées aux réservations sont enregistrées.',
    bookingNotChanged: 'Les modifications n\'ont pas pu être enregistrées.'
  },
  dashboard: {
    pricing: 'Tarification',
    datanalytics: 'Analyses de données',
    customerManagement: 'Gestion client'
  },
  noAccess: {
    noAccess: 'Vous n\'êtes pas autorisé à afficher cette page',
    goToLogin: 'Se connecter'
  },
  selectDate: {
    fromPrice: 'du prix',
    selectDayInCalendar: 'Sélectionnez un jour dans le calendrier',
    addTicketHint: 'Ajouter un billet',
    totalWithDiscount: 'Total réductions comprises',
    pricesFor: 'Affichage des prix',
    who: 'Ajouter des personnes',
    infoHeader: 'Sélectionnez les dates appropriées',
    infoText: 'Choisissez les bonnes dates de votre séjour. Vous pouvez choisir de 1 à 14 jours maximum. Vous pouvez modifier la durée dans la liste.'
  },
  bookingOptions: {
    reclassification: 'Changement de réservation',
    basic: 'Basic',
    flex: 'Flex',
    selectTarif: 'Choisissez votre tarif',
    basicTarif: 'Tarif Basic',
    flexTarif: 'Tarif Flex',
    chooseYourExtras: 'Choisissez vos suppléments',
    dateSelected: 'Dates sélectionnées',
    optionOnlyForFullDayAvailable: 'Option disponible uniquement pour le forfait journée',
    addOption: 'Ajouter un supplément'
  },
  personalData: {
    newCustomer: 'Je suis un nouveau client',
    registerNow: 'Inscrivez-vous maintenant',
    alreadyCustomer: 'Je suis déjà client',
    furtherWithoutRegistration: 'Continuer sans compte',
    whereToStoreTheTicket: 'Veuillez choisir l\'emplacement de l\'enregistrement',
    saveTicketHere: 'Mon forfait doit être enregistré ici',
    whereToDeliver: 'Où devons-nous livrer les forfaits?',
    toWhomBelongsTicket: 'A qui appartiennent les forfaits?',
    addNewPerson: 'Ajouter une nouvelle personne',
    addNewCard: 'Ajouter une nouvelle carte',
    cardBuyMsg: 'La KeyCard est achetée. Il peut être rechargé aussi souvent que souhaité.',
    selectCard: 'Sélectionner une carte',
    newSwisspass: 'Ajouter un nouveau SwissPass',
    newKeyCard: 'Pas de Keycard. Ajouter maintenant.',
    tooYoung: 'La personne est trop jeune pour le forfait',
    tooOld: 'La personne est trop agée pour le forfait',
    personAlreadyInUse: 'La personne a déjà été choisie pour un autre forfait.',
    advantage1: 'Recevez des offres exclusives',
    advantage2: 'Réservez votre journée de ski plus rapidement désormais',
    advantage3: 'Réservez simplement pour la famille et les amis'
  },
  bookingOverview: {
    dayDiscounts: 'Remise de plusieurs jours',
    flexTarif: 'Tarif Flex',
    subtotal: 'Sous-total',
    addNewPerson: 'Ajouter une nouvelle personne',
    vouchers: 'Bon d\'achat',
    familyDiscount: 'Remise famille',
    areYouFamily: 'Etes-vous une famille?',
    commingAsFamily: 'Confirmer',
    familyDiscountAdvantages: 'En tant que famille, vous pouvez bénéficier de réductions intéressantes. Veuillez confirmer, ' + 'que les billets enfants sélectionnés sont destinés aux enfants de votre famille.',
    spotChecksPossible: 'Des échantillons peuvent être prélevés.',
    bookingOverview: 'Aperçu des réservations'
  },
  success: {
    authtokenProblem: 'Vous avez peut-être désactivé les cookies. Veuillez vous reconnecter et valider à nouveau la réservation dans votre profil.',
    missingLiability: 'Il y a un problème. Provenant apparemment de votre banque.',
    checkForPaymentStatus: 'Nous vérifions en arrière-plan si le paiement a été effectué.',
    paymentErrorTryAgain: 'Cliquez ici pour recommencer le paiement',
    paymentSuccessfull: 'Paiement effectué avec succés, nous vous remercions',
    paymentSuccessfullSubheading: 'Nous nous réjouissons de votre prochaine visite',
    paymentSuccessfullSubheadingChaeserrugg: 'Nous vous souhaitons un séjour reposant dans la région du Chäserrugg.',
    unknowError: 'Erreur inconnue',
    goToBookingOverview: 'Vers l\'aperçu de la réservation',
    retryPayment: 'Essayer à nouveau',
    bookingTooOld: 'La réservation a expiré',
    goBack: 'Nouvelle réservation'
  },
  purchase: {
    voucherInput: 'Entrer le bon d\'achat',
    voucherNotValidated: 'Ce bon n\'a pas encore été ajouté.',
    cashVoucher: 'Utilisez un code promotionnel',
    bookNow: 'Réservez maintenant',
    validateVoucher: 'Chèque cadeau',
    voucherAlreadyAdded: 'Le bon-cadeai a déjà été ajouté',
    pricesTooOld: 'Malheureusement votre temps de réservation a expiré.',
    notAllowed: 'Vous n\'êtes pas autorisé à acheter un billet pour les utilisateurs sélectionnés.',
    invalidTicketMode: 'Mode ticket non valide. Veuillez contacter le support.',
    selectedKeycardWrong: 'La carte de ski sélectionnée n\'appartient pas à l\'utilisateur sélectionné',
    tryingToBookInThePast: 'Vous essayez d\'acheter un billet dans le passé.',
    ticketCategoryInvalid: 'La catégorie de forfait n\'est pas valide. Veuillez contacter le support',
    invalidTicketType: 'Type de forfait non valide. Veuillez contacter le support',
    wrongOrderOfTickets: 'Erreur de commande: mauvaise commande de forfait. Veuillez contacter le support',
    wrongTimeZone: 'Vous ne pouvez pas réserver de forfaits dans ce créneau horaire. Veuillez contacter le support.',
    invalidOption: 'Option sélectionnée non valide. Veuillez contacter le support',
    amountFailed: 'Une erreur s\'est produite lors du calcul du prix. Veuillez contacter le support.',
    flexBasicCombination: 'Une erreur s\'est produite avec les options Flex / Basic. Veuillez contacter le support.',
    newShadowUserNotCreated: 'L\'utilisateur n\'a pas pu être ajouté. Veuillez contacter le support.',
    newSkiCardNotCreated: 'La carte de ski n\'a pas pu être ajoutée pour le nouvel utilisateur. Veuillez contacter le support.',
    goToMyBookings: 'Vers l\'aperçu de la réservation',
    buyMore: 'Achetez plus de forfaits',
    acceptAgs: 'Veuillez lire et accepter la politique de confidentialité et les conditions générales pour terminer la réservation.',
    IAcceptAgb: 'J\'ai lu la politique de confidentialité, les termes et conditions et je les accepte.',
    accept: 'Accepter',
    addMissingUserDataModalHeader: 'Presque terminé',
    vaucherInput: 'Utilisez le bon d\'achat',
    decline: 'Refusé',
    book: 'Réservé',
    voucherInfoText: 'Si vous avez reçu un code de crédit en ligne, vous pouvez le saisir ici. Vous pouvez ' + 'également retrouver tous vos codes de crédit en ligne dans votre profil (<span class="fa fa-user"></span>).'
  },
  outOfTime: {
    runOutOfTime: 'Malheureusement, votre temps de réservation a expiré.',
    reloadData: 'Redémarrez le processus de réservation'
  },
  dataTable: {
    noDataAvailable: 'Pas de données disponibles',
    noResultFound: 'Aucun résultat',
    allRows: 'Tout'
  },
  dataFooter: {
    pageText: '{0}-{1} de {2}',
    itemsPerPageText: 'Éléments par page:',
    itemsPerPageAll: 'Tout',
    itemsPerPageAllText: 'Tout',
    nextPage: 'Page suivante',
    prevPage: 'Page précédente',
    firstPage: 'Première page',
    lastPage: 'Dernière page'
  },
  myBookings: {
    myBookings: 'Mes réservations',
    newBookings: 'Nouvelles réservations',
    oldBookingsHeader: 'Mon historique de réservations',
    reference: 'Numéro de réservation.',
    persons: 'Personnes',
    destination: 'Station de ski',
    cancelBooking: 'Annuler la réservation',
    cancelBookingModalTitle: 'Dommage que vous ne puissiez pas commencer votre journée de ski!',
    cancelBookingInformationA: 'Ici, vous pouvez annuler votre réservation et la convertir en bon d\'achat. Vous pouvez trouver également plus d\'informations',
    cancelBookingInformationB: 'Quels billets doivent être annulés et convertis en bon d\'achat?',
    cancelButton: 'Annuler',
    areYouSure: 'Etes-vous sûr?',
    confirm: 'Confirmer',
    overviewTicketsToCancelText: 'Le forfait suivant sera annulé et converti en bon d\'achat',
    ticketsSuccessfullyCanceled: 'Les forfaitss ont été annulés et convertis en bon d\'achat.',
    ticketsNotCanceled: 'Les forfaits n\'ont pas pu être annulés en raison d\'une erreur technique.',
    isFlex: 'Non annulable',
    isStorno: 'annulé',
    details: 'Détails de réservation',
    noBookingFound: 'La réservation a expiré ou n\'existe pas',
    ticketNr: 'Numéro de forfait.',
    noOptions: 'pas d\'options',
    dataMedium: 'Support de stockage',
    pdfIsGenerating: 'Le PDF est généré. Cliquez pour réessayer.',
    downloadTicket: 'Forfait tékéchargé',
    ticketNotPaid: 'Le forfait n\'a pas été payé.',
    paymentDetails: 'Détails du paiement Réservation totale',
    services: 'Prestations'
  },
  myVauchers: {
    myVauchers: 'Mon bon d\'achat',
    vaucherCode: 'code promotionnel',
    credit: 'crédit',
    maxDate: 'valable jusqu\'à',
    description: 'Vous pouvez utiliser votre crédit en ligne pour acheter de nouvelles offres dans la boutique en ligne.',
    cashVaucher: 'Bon en espèces',
    noDataAvailable: 'Pas de crédit en ligne disponible'
  },
  cardsList: {
    addCard: 'SwissPass / Keycard',
    noCardsAvailable: 'Aucune carte disponible',
    unknownCardType: 'Carte inconnue',
    description: 'Description'
  },
  overviewTicketOffice: {
    searchTicketCode: 'Code forfait validé ',
    addSwisspass: 'SwissPass ajouté',
    addKeyCard: 'Keycard ajoutée',
    checkMail: 'Nous vérifions l\'email',
    keyCardAdded: 'La Keycard a été ajouté.'
  },
  ticketOffice: { addSwisspass: 'SwissPass ajouté' },
  optionTable: { checkingAvailability: 'Nous vérifions la disponibilité.' },
  bookingManagement: {
    loadingCamera: 'La caméra charge...',
    validate: 'Valider',
    storno: 'Révoquer le billet',
    serachByName: 'Rechercher par le nom',
    scanTicketCode: 'Ticket scanné',
    ticketInvalidated: 'Le ticket a été validé avec succès',
    ticketNotInvalidated: 'Le ticket n\'a pas pu être validé',
    user: 'Informations personnelles',
    pricePaid: 'Prix payé',
    days: 'Période de résevation',
    validatedBy: 'Validé par',
    ticketStornoSuccessfull: 'Le forfait a été converti avec succès en bon d\'achat',
    reallyStorno: 'Souhaitez-vous vraiment annuler?',
    ticketStornoExplanaition: 'Le billet sera converti en bon d\'achat de la boutique Pricenow.',
    ticketAlreadyValidated: 'Le forfait a déjà été validé!',
    ticketAlreadyCancelled: 'Le forfait a déjà été annulé!',
    cancelledBy: 'Annulé par',
    cancelledAt: 'Annulé à',
    ticketNotPaid: 'Le forfait n\'a pas été payé et n\'est pas valide!',
    selectTicket: 'Sélection le forfait',
    ticketFromTo: 'Période de réservation',
    ticketCode: 'Numéro de référence',
    ticket: 'Forfait',
    stornoNotPossible: 'Non annulable!',
    flexCanBeCancelled: 'Flex:annulable',
    stornoConditions: 'Conditions d\'annulation',
    minChar: 'Saisissez au moins 3 lettres pour rechercher',
    falseAccessRights: 'Malheureusement, vous ne disposez pas des droits nécessaires. Veuillez contacter le support.',
    putTicketsOnKeyCard: 'Charger le ticket sur la Keycard',
    resetKeyCardUid: 'réinitialiser',
    withoutDepot: 'Sans dépôt',
    withDepot: 'Avec dépôt',
    ticketToCardAddedSuccessfully: 'Forfait chargé avec succès sur la Keycard',
    ticketAlreadyOnCard: 'Le forfait a déjà été chargé sur une Keycard!',
    skiCardNumberNotValid: 'Le numéro de la Keycard n\'est pas valide',
    noTicketsProvided: 'Erreur technique: aucun forfait lisible.',
    ticketOverview: 'Aperçu du forfait',
    ticketDoesNotExistInDatabase: 'Le forfait n\'existe pas dans cette base de données',
    skidata: 'Skidata',
    putOnKeycard: 'Forfait sur la Keycard',
    externalTicketProvider: 'Statut du système de ticketing externe'
  },
  overviewPricing: {
    visitors: 'Visiteur',
    visitorsForecast: 'Prévisions des visiteurs',
    pricesForecast: 'Evolution des prix',
    discountsOverview: 'Aperçu de la remise',
    actualPrice: 'Prix actuel',
    discountSum: 'Remise',
    earlyDiscount: 'Réduction pour réservation anticipée',
    phaseDiscount: 'Réduction selon la période',
    weekdayDiscount: 'Réduction selon le jour de la semaine',
    weatherDiscount: 'Réduction en fonction de la météo',
    overrideModalHeader: 'Ajustements pour',
    currentPrice: 'Prix actuel',
    inputRequired: 'Vous devez entre un prix.',
    maxPrice: 'Prix maximal',
    changingReason: 'Motif du changement',
    newParamsStored: 'Nouveaux paramètres enregistrés',
    guests: 'Invités',
    ticketPrice: 'Prix du forfait (CHF)',
    // not in use
    differentDiscounts: 'Remise (%)',
    noMoreFuture: 'L\'affichage n\'est pas possible',
    reallySaveChanges: 'Voulez-vous vraiment enregistrer les modifications?',
    weatherCanNotBeChanged: 'La date est trop éloignée et ne peut pas être réglée manuellement.',
    commentRequired: 'Veuillez indiquer la raison du changement.',
    product: 'Produit',
    price: 'Prix',
    bookings: 'Réservations',
    noChartData: 'Pas de données disponibles',
    weekRange: 'Période',
    startDate: 'Date de début',
    regions: 'Regions',
    week: 'Semaine',
    weeks: 'Semaines',
    quantity: 'Quantité',
    countSelectedDefinitions: 'Les {counter} Produits sélectionnés',
    cannotShowAllEntriesInTables: 'Toutes les définitions de produits sélectionnées ne peuvent pas être affichées dans le graphique.',
    postedPrices: 'Prix',
    targetPrices: 'Prix cibles',
    overwrite: 'Modifier les prix',
    history: 'Historique des prix',
    undefined: 'Non défini'
  },
  captureUsers: {
    insertMail: '1. Saisissez l\'adresse e-mail du client',
    captureSwisspass: '2. Enregistrer votre SwissPass',
    createNewUser: '3. Complétez les informations',
    unknownResponseStatus: 'Code-réponse inconnu',
    userAlreadyExists: 'L\'utilisateur existe déjà',
    userAlreadyExistsExplanation: 'C\'est tout bon! La personne est déjà enregistrée dans notre système. Vous pouvez fermer la fenêtre.',
    checkSwisspass: 'Vérifier SwissPass',
    swisspassCombinationWrong: 'Le numéro SwissPass et le code postal ne correspondent pas ou sont incorrects.',
    shwadowUserAlreadyExists: 'La personne est déjà enregistrée dans notre système, mais ne s\'est encore jamais connectée. ' + 'Nous lui avons donc envoyé un e-mail avec les informations nécessaires. Vous pouvez fermer la fenêtre.',
    mailSent: 'E-Mail envoyé'
  },
  registrationForm: {
    userAlreadyExists: 'Un utilisateur avec cet e-mail existe déjà. Veuillez saisir votre mot de passe pour vous connecter.',
    phoneNumberForQueries: 'Numéro de téléphone pour les requêtes',
    salutation: 'Salutation',
    salutationStar: 'Salutation *',
    selectSalutation: 'Merci de sélectionner les salutations',
    followingDestination: 'Vous vous êtes déjà inscrit dans l\'une des destinations suivantes',
    useYourPassword: 'Connectez-vous avec votre mot de passe. Si vous avez oublié votre mot de passe, vous pouvez le réinitialiser.'
  },
  SCountry: {
    country: 'Pays',
    countryMandatory: 'Pays *',
    countryIsMandatory: 'Merci de sélectionner un pays'
  },
  missingUserData: {},
  bookingDetail: {
    showDetails: 'Voir les détails',
    hideDetails: 'Cacher les détails',
    noOptions: 'pas d\'option',
    cancellationNumbers: 'Numéro d\'annulation',
    unpaidBookingCannotHaveAnAmount: 'Une erreur s\'est produite: la réservation non payée ne peut pas être annulée avec un montant supérieur à CHF 0.',
    unpaidBookingToReleaseCapacities: 'Cette réservation n\'est pas payée. Avec l\'annulation, les éventuelles restrictions de capacité sont à nouveau levées.',
    voucherAmount: 'Créer des crédits en ligne',
    voucherFor: 'Crédit en ligne pour',
    stornoForZero: 'Les réservations faites au nom d\'un employé de la destination doivent être annulées avec 0 franc!',
    noVoucherWillBeCreated: 'Aucun crédit en ligne n\'est créé.',
    editBookingEntries: 'Modifier Services',
    closeEditBookingEntries: 'Annuler le traitement',
    editBuyer: 'Modifier l\'acheteur',
    validGA: 'AG en cours de validité',
    invalidGA: 'Pas d\'AG valable',
    validHTA: 'Demi-tarif valable',
    invalidHTA: 'Pas de demi-tarif valable'
  },
  loginForm: {
    noAccount: 'Pas encore de compte? Inscrivez-vous maintenant',
    loginNow: 'Connection',
    transferDataRequest: 'Pouvons-nous reprendre vos données ?',
    tranferDataText: 'Vos données sont déjà enregistrées chez nous. Pouvons-nous les reprendre pour la destination {destination}?',
    transferDataTextII: 'En donnant votre accord, vous acceptez en même temps les conditions générales de la destination {destination}. ' + 'Vous trouverez les conditions générales actuelles en lien en bas de cette page web.',
    accept: 'Accepter',
    decline: 'Refuser',
    authenticationFailed: 'Le mot de passe ou l\'adresse e-mail est incorrect. Veuillez vérifier votre saisie et réessayer.'
  },
  paymentHandler: { goToBooking: 'Retour à l\'accueil' },
  bookingTarifs: {
    fare: 'Tarif',
    basicDescription: 'Avec le tarif <span class="font-weight-bold">Baisc</span> , vous achetez un forfait de ski qui ne peut être ni modifié ni annulé. ' + 'En cas d\'annulation, la totalité de la réservation sera annulée. ' + 'Annulation de journées de ski individuelles. Un ticket de plusieurs jours n\'est pas possible. ' + 'Le montant de la réservation initiale vous sera crédité sous forme de bon, que vous recevrez ' + 'ensuite lors de votre prochaine ' + 'Peut utiliser la réservation en ligne. ' + '<br> <br> ' + 'Avec le <span class =" font-weight-bold "> tarif facultatif </span> ' + '(par exemple, 3 jours sur 4), vous obtiendrez un ticket, qui vous donne la possibilité ' + 'de suspendre n\'importe quel jour de la période choisie, par ex. par mauvais temps. ',
    moreInformation: 'Veuillez trouver plus d\'informations ici'
  },
  bookingLogin: { futureAdvantages: 'Profitez des avantages exceptionnels à venir' },
  v2: {
    OptionsCouldNotBeenLoaded: 'Les options n\'ont pas pu être chargées',
    soldOut: 'épuisé',
    availableOptions: 'encore {availableOptions} offres.'
  },
  v3: {
    pleaseConfirmMail: 'Merci de confirmer votre adresse e-mail',
    confirm: 'Confirmer',
    mailSuccessfullyConfirmed: 'Merci beaucoup! Votre adresse e-mail a été confirmée avec succès.',
    goToLogin: 'Connexion',
    pleaseSetPw: 'Presque terminé! Définissez un mot de passe.',
    usedTicketCannotBeCancelled: 'Les billets valables à partir d\'aujourd\'hui doivent également être annulés dans le système de billetterie!'
  },
  v4: {
    amount: 'Montant',
    unknownError: 'Une erreur inconnue s\'est produite (483). Veuillez contacter le support.',
    apiWasNotAbleToCalculateThePrice: 'Une erreur s\'est produite lors du calcul du prix. Veuillez contacter le support.',
    triesToBookATicketForWrongAge: 'Vous essayez de réserver un forfait sur un support de données (par exemple Swisspass) qui ne remplit pas les conditions d\'âge.',
    ticketOrOptionCostsLessThanZero: 'Vous essayez d\'acheter un forfait ou une option d\'un coût inférieur ou égal à 0 franc. Veuillez contacter le support.',
    skiCardAlreadyInUse: 'La carte est déjà utilisée. Veuillez en choisir une autre.',
    stornoAmount: 'Montant',
    stornoReasonRequired: 'Veuillez indiquer la raison de l\'annulation.',
    giveMeAStornoReason: 'Raison de l\'annulation',
    stornoAmountRequired: 'Veuillez saisir le montant à annuler.',
    stornoHistory: 'Historique des annulations',
    selfStorno: 'Utilisateur lui-même',
    cashDeskStorno: 'Employés / administrateurs de guichet',
    selectCancellationType: 'Annulation par',
    selectCancellationTypeRequired: 'Veuillez sélectionner un type d\'annulation',
    cancellationDate: 'Annulé le',
    noVoucherHasBeenGenerated: 'Pas de bon',
    voucherOriginalRatio: 'Valeur du bon / prix du billet payé',
    filter: 'Filtre',
    noNameFound: 'Aucun nom trouvé',
    ticketUser: 'Propriétaire du forfait',
    alreadyUsed: 'Racheté',
    cancellationDetailModalHeader: 'Annulation des détails',
    cancellation: 'Annulation',
    voucherValue: 'Valeur du bon',
    paidOriginalTicketPrice: 'Prix d\'origine payé',
    ticketOwner: 'Forfait',
    voucherOwner: 'Propriétaire du bon',
    voucherOwnerInfo: 'Le propriétaire du bon peut différer du propriétaire du forfait car l\'acheteur d\'un forfait n\'est pas nécessairement le propriétaire du forfait.',
    noVoucherGeneratedInfo: 'Aucun bon n\'a été créé. Le forfait peut avoir été généré avec une valeur de 0 CHF.',
    // ohne Wert
    tooLateForCancellation: 'Le forfait ne peut plus être annulé. L\'annulation n\'est possible que jusqu\'à 23 h 59 la veille du premier jour de ski.'
  },
  v5: {
    seeYouInAutomn: 'Nous reviendrons vers vous dès l\'automne',
    goodPricesSoon: 'Ensuite, vous pourrez réserver à nouveau vos forfaits de ski ici à des prix avantageux.',
    sommerTickets: 'Les billets pour le train d\'été sont actuellement disponibles à la billetterie.',
    goodSommerInTheMeanTime: 'Nous nous réjouissons de votre visite et vous souhaitons d\'ici là un bel été à Bellwald.',
    startdate: 'Choisissez la date début',
    searchPlaceholder: 'Chercher',
    selectDate: 'Veuillez choisir une date.',
    selectDuration: 'Veuillez sélectionner le nombre de jours.',
    durationDropdown: 'Nombre de jours',
    basketInProgress: 'Vous devez d\'abord configurer tous les produits de votre panier avant de pouvoir en ajouter de nouveaux.',
    basketUpdateNotSuccessfull: 'Malheureusement, le panier n\'a pas pu être mis à jour.',
    twoPossibilities: 'Vous avez deux possibilités pour saisir le numéro Swisspass',
    scanQrCode: 'Tenez le code QR (1) de votre SwissPass devant la caméra de votre téléphone portable / PC.',
    cameraCapturing: 'Capture par caméra',
    manualCapturing: 'Enregistrement manuel',
    captureSwisspassNumber: 'Dans le champ "Numéro de carte", saisissez votre numéro de SwissPass à 11 chiffres, S inclus mais sans tirets. ' + 'Vous trouverez ce numéro au dos de votre SwissPass (2).',
    keyCardCatpuring: 'Enregistrez le numéro de la KeyCard',
    keyCardInputExplanation: 'En principe, vous pouvez utiliser n\'importe quelle carte-clé de SKIDATA (même d\'autres domaines skiables). ' + 'Pour ce faire, saisissez dans le champ "Numéro de carte" le numéro à 23 chiffres figurant au recto de votre Keycard. La saisie se fait sans tirets.',
    completeUserData: 'Pour effectuer la commande, veuillez compléter les informations demandées (*)',
    paymentAlreadyVerified: 'La réservation a déjà été vérifiée.',
    total: 'Total',
    pdf: 'PDF',
    downloadPdf: 'Télécharger le PDF',
    noPdfAvailable: 'Cette réservation ne comprend pas de fichier PDF.',
    vouchers: 'Bon d\'achat',
    productsAlreadyInBasket: 'Produits déjà dans le panier',
    basket: 'Panier',
    navigationErrorNoBasketEntriesInState: 'Ajoutez au moins un produit au panier ou cliquez sur Retour.',
    continueShopping: 'Continuer vos achats',
    currentBasketWillBeDeleted: 'Le panier sera supprimé!',
    areYouSureDeletingBasket: 'Si vous vous déconnectez lors de vos achats, votre panier sera supprimé et le processus de réservation en cours sera réinitialisé. Voulez-vous continuer?',
    notAvailable: 'Il n\'y a pas de billets disponibles actuellement',
    dataMediaAmount: '<b>Vous avez les possibilités suivantes pour recharger votre billet</b> <br><br>',
    dataMediumSwisspass: '<b>SwissPass</b> <br>' + '<ul>' + '<li>' + 'Saisie par appareil photo : présentez le code QR de votre SwissPass devant l\'appareil photo de votre téléphone portable/ordinateur.' + '</li>' + '<li>' + 'Saisie manuelle : dans le champ "Numéro de carte", saisissez votre numéro de SwissPass à 11 chiffres <u>y compris le S mais sans</u> tirets.<br>' + 'Vous trouverez ce numéro au dos de votre SwissPass.' + '</li>' + '<li>' + '- Capture par caméra: Tenez le code QR de votre SwissPass devant la caméra sur votre téléphone portable / PC.<br>' + '- Saisie manuelle: entrez votre numéro SwissPass à 11 chiffres, y compris le S sans tirets dans le champ "Numéro de carte" <u>ohne</u> Vous trouverez le numéro au dos de votre SwissPass.<br>' + '- Votre forfait de ski est automatiquement enregistré sur votre SwissPass et vous pouvez démarrer directement sur les pistes sans avoir à faire la queue au guichet.',
    dataMediumSkidata: '<b>Carte-clé SKIDATA</b> <br>' + '<ul>' + '<li>En principe, vous pouvez utiliser n\'importe quelle carte-clé de SKIDATA (même d\'autres domaines skiables). Pour ce faire, entrez dans le champ "Numéro de carte" le numéro à 23 chiffres de la carte. ' + 'du recto de votre Keycard. La saisie se fait sans tirets.' + '</li>' + '<li>Votre forfait de ski est automatiquement enregistré sur cette Keycard et vous pouvez partir directement sur les pistes sans faire la queue au guichet des caisses. ' + 'Pour pouvoir attribuer rapidement la carte à une personne, donnez-lui un nom, par exemple Keycard_Michael.' + '- Vous pouvez utiliser n\'importe quelle carte-clé SKIDATA (également d\'autres domaines skiables). Pour ce faire, saisissez le numéro à 23 chiffres à l\'avant de votre Keycard dans le champ "Numéro de carte". L\'entrée se fait sans tirets.<br>' + '-Votre forfait de ski est automatiquement enregistré sur cette keycard et vous pouvez commencer directement sur les pistes sans avoir à faire la queue au guichet. Pour attribuer rapidement la carte à une personne, donnez-lui un nom, par ex. Keycard_Michael.',
    dataMediumPrintAtHome: '<b>Print@Home</b><br>' + '<ul><li>Après avoir passé votre commande, vous recevrez un PDF par e-mail, que vous pourrez soit imprimer, ' + 'soit scanner sur votre téléphone portable directement lors de votre passage. Une visite au guichet n\'est pas ' + 'nécessaire. Vous trouverez également tous les billets réservés dans votre aperçu des réservations.' + '</li></ul>',
    dataMediumPickup: '<b>Pick-up / prise en charge sur place</b><br>' + 'imprimer et présenter à la caisse. Vous recevrez alors une KeyCard, que vous devriez idéalement conserver ' + 'pour votre prochaine réservation en ligne.' + '</li></ul>',
    dataMediumAxess: '<b>Axess KeyCard</b><br>' + '<ul><li>En principe, vous pouvez utiliser n\'importe quelle KeyCard d\'Axess (même d\'un autre domaine skiable). ' + 'Pour ce faire, saisissez dans le champ "Numéro de carte" le numéro figurant au dos de votre KeyCard. La saisie ' + 'se fait <u>avec un trait d\'union</u>.' + '</li></ul>',
    dataMediumPrintAtHomeSchnaager: '<b>Print@Home</b><br>' + 'Après avoir passé votre commande, vous recevrez par e-mail un PDF que vous pourrez imprimer et envoyer par courrier électronique. ' + 'à présenter au chauffeur de l\'Alpuschnaager. Vous pouvez également présenter le ticket de ramassage sur votre smartphone.',
    onlyFewTicketsLeft: 'maximum de forfaits disponibles à ce prix',
    voucherAlreadyUsedInOtherBooking: 'Réservation invalide. Vous avez déjà utilisé le bon dans une autre réservation.',
    paymentForBookingNotFound: 'Le paiement de la réservation est introuvable. Veuillez contacter le support.',
    paymentFailed: 'Paiement échoué. Veuillez réessayer par exemple avec une autre carte de crédit.',
    calculatingPrices: 'Chargement des prix',
    depot: 'Dépôt',
    choosingPersonForTicket: 'sélectionner «{ticket}» pour une personne',
    gotToBackend: 'allé au backend'
  },
  v6: {
    showFilter: 'Afficher les filtres',
    hideFilter: 'Masquer les filtres',
    noNewPrice: 'Le nouveau prix n\'a pas pu être fixé car il était nul.',
    setNewPrice: 'Etablir un nouveau prix?',
    newPrice: 'Nouveau prix (CHF)',
    // not in use
    OverwritePrice: 'Etablir un nouveau prix',
    newPriceRequired: 'Veuillez saisir un nouveau prix.',
    confirmOverwritePrice: 'Êtes-vous sûr que le prix du forfait pour la {date} doit être remplacé par {prix} CHF? ',
    sure: 'Êtes-vous sûr?',
    minimalPrice: 'Prix minimum',
    correctedDate: 'Votre réservation a pris plus de temps que notre saison. C\'est pourquoi nous avons automatiquement ajusté votre sélection de date au dernier jour possible.',
    addCard: 'Swisspass / Keycard ajouté',
    addNoCard: 'Aucune carte ajoutée',
    includingCardFees: 'inclus{frais} de dépôt',
    allBookingEntriesCancelled: 'Forfaits annulés - pas de PDF',
    ticketCancelled: 'Le forfait a été annulé',
    overwirteAllPrices: 'Changer les prix',
    priceSuccessfullyOverwritten: 'Le prix a été modifié avec succès.',
    overwrittenPrice: 'Ecrasé',
    resetPrice: 'Réinitialiser le prix',
    youOverwriteTheFollowingTicket: 'Vous remplacez le produit suivant',
    reset: 'Réinitialiser',
    dateRequired: 'Aucune date sélectionnée',
    priceSuccessfullyReset: 'Le prix a été réinitialisé avec succès.',
    ownForecast: 'Propres prévisions',
    lastUpdated: 'Dernière mise à jour le',
    resetOverwrittenPrice: 'Souhaitez-vous réinitialiser le prix écrasé manuellement au prix calculé automatiquement?',
    base: 'base'
  },
  discounts: { family: 'Remise Famille' },
  moduleNames: {
    skiTicket: 'Forfait',
    skiTicketBellwald: 'Billets de ski',
    skiTicketVals: 'Forfait',
    sleddingTicket: 'Forfait Luge',
    trainRide: 'Voyage en train',
    trainNiesen: 'Vaoyage en train',
    tableReservationNiesen: 'Table pour le déjeuner',
    hotelNiesen: 'Nuitée',
    trainReservationNiesen: 'Réserver train',
    seasonAbosBellwald: 'Abonnement de saison',
    singleRideBellwald: 'Voyage simple',
    skiTicketChaeserrugg: 'Billets de ski',
    singleRideChaeserrugg: 'Voyage simple',
    seasonAbosChaeserrugg: 'Abonnements',
    hikingChaeserrugg: 'Billets de randonnée',
    skiMoosalpregion: 'Billets de ski',
    seasonAbosMoosalpregion: 'Abonnements',
    singleRideMoosalpregion: 'Trajets individuels',
    sledgeChaeserrugg: 'Billets de luge',
    bikeparkBellwald: 'Parc à vélos'
  },
  routingTitles: {
    overviewPricing: 'Aperçu',
    pricingDetails: 'Tarification',
    pricingSettings: 'Paramètres',
    pricingWeather: 'Météo',
    pricingAnalytics: 'Analyses',
    profile: 'Mon profil',
    myBookings: 'Mes réservations',
    myProfiles: 'Utilisateur',
    myVouchers: 'Bon d\'achat',
    bookingOverview: 'Réservations',
    extraRide: 'Groupes',
    stornoHistory: 'Annulations',
    pricingTable: 'Affichage des prix',
    capacity: 'Capacités',
    products: 'Produits',
    events: 'Evènements',
    cashDesk: 'Guichet',
    reports: 'Rapports',
    settings: 'Paramètres'
  },
  calendar: {
    days: {
      mo: 'Lu',
      tu: 'Ma',
      we: 'Me',
      th: 'Je',
      fr: 'Ve',
      sa: 'Sa',
      so: 'Di'
    },
    soldOut: 'occupé',
    productNotAvailableOnDate: 'Produit non disponible à cette date',
    notAvailable: 'Indisponible'
  },
  weather: {
    weatherIn: 'Prévisions météo',
    edit: 'Changer',
    title: 'Sélection la météo',
    changeForecast: 'Ajuster',
    changeWeatherConfirmation: 'Ajuster les prévisions',
    ok: 'Ok',
    nok: 'Annuler',
    acceptChanges: 'Voulez-vous accepter la modification suivante?'
  },
  pricingDetails: {
    percentage: '%',
    weekdayChartLabel: '% Supplément',
    weekdayChartTitle: 'Supplément %',
    valdemChartYLabel: 'Supplément chf',
    dates: 'Dates',
    filterChoice: 'Options de filtres',
    days: 'Jours',
    weekdays: 'Jours de la semaine',
    seasonPhases: 'En saison et jourés fériés',
    priceCombo: 'Prix total (CHF)',
    // not in use
    totalPrice: 'Prix total',
    valDem: 'Valeur et demande',
    value: 'Valeur',
    demand: 'Demande',
    dailyBaseRate: 'Prix aujourd\'hui',
    multiDayDiscount: 'Remise séjours - Prix cible du produit',
    maximumEarlyBooking: 'Niveau de remise pour les réservations anticipées',
    cashDeskPrice: 'Prix cibles'
  },
  productSelector: {
    noProductsAccess: 'Aucun produits',
    loadingProducts: 'Chargement des produits...'
  },
  weekdays: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche'
  },
  footer: {
    links: 'Liens',
    acceptedPayments: 'Moyens de paiements acceptés',
    contact: 'Contact',
    poweredBy: 'parrainé par'
  },
  apiPage: {
    notFound: 'Erreur',
    notFoundDesc: 'Impossible de trouver la page'
  },
  attributes: {
    region: 'Région',
    age: 'Types de personnes',
    duration: 'Durée',
    flex: 'Type d\'avantages',
    performanceDiff: 'Différenciation des performances',
    room: 'Chambre',
    train: 'Voyage en train',
    adults: 'Adultes',
    children: 'Enfants',
    route: 'Trajet',
    from: 'de',
    to: 'à',
    swisspass: 'Remise',
    time: 'Temps',
    personAmount: 'Nombre de personnes',
    trainAdults: 'Trajet adultes',
    trainChildren: 'Trajet enfants',
    meal: 'Repas',
    tarif: 'Tarif',
    voucherType: 'Type de bon',
    warningTexts: { gaHalbtax: { niesen: 'Toutes les réductions (AG ou abonnement demi-tarif) sont effectuées à la fin de la réservation.' } }
  },
  performanceDiffAdvantages: {
    ski: 'Forfait',
    flexibility: 'Flexibilité',
    cancellation: 'Annulation'
  },
  performanceDifferentiation: { outOfDays: '{durationDays} de {durationDaysPlus} jours' },
  emergencyDown: { text: 'Veuillez excuser l\'interruption. Nous effectuons actuellement une mise à jour et nous vous répondrons sous peu.' },
  extraRides: {
    extraRides: 'Groupes',
    fromDate: 'de',
    toDate: 'à',
    name: 'Nom',
    date: 'Date',
    ascent: 'Ascension',
    ascentTime: 'Durée de l\'ascension',
    descent: 'Descente',
    descentTime: 'Durée de la descente',
    addedBy: 'Crée par',
    updatedAt: 'Crée à',
    comment: 'Commentaire',
    edit: 'Modifier',
    noDataAvailable: 'Aucun groupe entré',
    newExtraRide: 'Créer un nouveau groupe',
    editExtraRide: 'Modifier le groupe',
    applyExtraRide: 'Enregistrer le trajet en train',
    applyChanges: 'Sauvegarder les modifications',
    deleteExtraRide: 'Supprimer le groupe',
    confirmDeletion: 'Voulez-vous vraiment supprimer ce groupe?',
    cancelEditing: 'Annuler',
    newExtraRideSuccessfull: 'Un nouveau groupe a été entré',
    deletionSuccessfull: 'Le groupe a été supprimé',
    editSuccessfull: 'Des changements ont été appliqués',
    updateNotSuccessfull: 'Impossible de charger les groupes',
    editNotSuccessfull: 'Le groupe sélectionné n\'a pas pu être chargé',
    deletionNotSuccessfull: 'Impossible de supprimer le groupe',
    descDateError: 'La descente ne peut se faire avant l\'ascension',
    ascentDateNotSet: 'Veuillez sélectionner une date pour l\'ascension',
    ascentTimeNotSet: 'Veuillez sélectionner une heure pour l\'ascension',
    descentDateNotSet: 'Veuillez sélectionner une date pour la descente',
    descentTimeNotSet: 'Veuillez sélectionner une heure pour la descente'
  },
  shopBackendBookingOverview: {
    all: 'Tout',
    aggregated: 'Agrégé',
    byCustomer: 'Selon le client',
    date: 'Date',
    product: 'Produit',
    personCount: 'Nombre de personne',
    customer: 'client',
    time: 'temps',
    bookingState: 'Statut de réservation',
    remark: 'Commentaire',
    customerSearch: 'Recherche client',
    searchDefaultText: 'Recherche par prénom, nom de famille, ville',
    tooManyWords: 'Pas plus de quatre mots autorisés',
    noSearchResult: 'Aucun résultat de recherche pour l\'instant',
    ticketCount: 'Forfait dans cette réservation',
    validity: 'Validité',
    bookingsOfTheUser: 'Publications de l\'utilisateur',
    calendar: 'Calendrier'
  },
  shopBackendBookingDetail: {
    buyer: 'Acheteur',
    missingId: 'Cette page n\'existe pas! Aucun identifiant de réservation disponible',
    remark: 'Commentaire',
    bookingState: 'Statut de réservation',
    paymentDetails: 'Détails du réglement',
    name: 'Nom',
    ticket: 'Forfait',
    price: 'Prix',
    save: 'Enregistrer',
    cancelMarkedTickets: 'Annuler les Forfaits sélectionnés',
    receivedMoney: 'Montant encaissé',
    printAllTickets: 'Imprimer les Forfaits',
    paymentState: 'Statut du réglement',
    cancelTicket: 'Annuler',
    abort: 'Annuler',
    cancellationAgreeText: 'Voulez-vous vraiment annuler les billets sélectionnés?',
    tickets: 'Forfaits de cette réservation',
    bookingStateWaitingList: 'Liste d\'attente',
    bookingStateProvisionally: 'Provisoirement',
    bookingStateManualConfirmed: 'Confirmé (par notre agent)',
    bookingStateAutoConfirmed: 'Confirmé (au magasin)',
    bookingStateDefinitive: 'Confirmé',
    paid: 'réglé',
    notPaid: 'non réglé',
    cancellationFaildForUnknownReason: 'L\'annulation a échoué pour une raison inconnue.',
    cancellationWasSuccessful: 'L\'annulation est confirmée',
    validFrom: 'valide à partir de ',
    skidataLockNumber: 'Numéro bloqué',
    dataMedium: 'Support de données',
    doNotForget: 'Ne pas oublier',
    cancellationGenerallyOk: 'Les bons ont été générés.',
    thirdPartySystemCancellationFailed: 'Nous n\'avons pas pu annuler automatiquement certains billets dans un système tiers. ' + 'Chez Skidata, vous pouvez essayer avec le numéro de réservation ou le numéro de blocage.',
    system: 'Système',
    ticketsUnCancelableAsNotPaid: 'Les forfaits ne peuvent pas être annulés car la réservation n\'est pas payée.',
    fromCity: 'de',
    noRemark: 'Aucun commentaire'
  },
  shopBackendBookingComplete: {
    day: 'Jour',
    fourDay: '4 jours',
    week: 'Semaine',
    month: 'Mois',
    timePeriod: 'Période',
    product: 'Produit',
    productDefinition: 'Dtails',
    customer: 'Client',
    time: 'Temps',
    bookingState: 'Statut de réservation',
    remark: 'Commentaire',
    extraTrip: 'Trajet supplémentaire',
    addBooking: 'Réservation ajoutée',
    xlsx: 'Liste Exportée',
    peopleCount: 'Nombre de personnes',
    capacity: 'Capacité',
    today: 'Aujourd\'hui',
    chooseDateRange: 'Période de requête',
    dateRangeDescription: 'Choisissez une seule date ou une date de début et de fin',
    expand: 'Se dérouler',
    aggregatedBookings: 'Réservations agrégées',
    bookingDate: 'Date d\'affichage',
    paymentTime: 'Délai de paiement',
    mail: 'E-mail'
  },
  skidata: {
    unknownState: 'Statut inconnu',
    ok: 'Statut: ok',
    cancellationSuccessfull: 'Annulé avec succès',
    unpaidNotInSkidata: 'Non réglé, pas à external ticket provider.',
    failedToCancelButInSkidata: 'L\'annulation external ticket provider a échoué.',
    failedToWriteToSkidata: 'Non écrit dans le système externe.',
    state: 'Statut',
    pickupCode: 'Code-barres',
    noBarcode: 'Ce ticket n\'a pas de code-barres.',
    orderId: 'Numéro de réservation',
    keycardHasToStartWith01: 'Le numéro doit commencer par 01.',
    invalidCard: 'numéro de carte invalide.'
  },
  pricingTable: { askAtTheCashDesk: 'Au guichet' },
  infoText: { vals: { ageRestrictions: 'Les enfants et adolescents nés en 2004 et après reçoivent un abonnement gratuit ' + 'à l\'office de tourisme de Visit Vals. Avec cela, le tourniquet peut être franchi toute la saison. ' + 'Des forfaits gratuits pour la journée des enfants sont disponibles à la station inférieure du téléphérique' } },
  shortCutTrainRide: {
    departure: 'Choisissez le lieu de départ',
    destination: 'Choisissez la destination',
    selectDeparture: 'Veuillez choisir le lieu de départ',
    selectDestination: 'Veuillez choisir le lieu de destination',
    selectRoute: 'Veuillez faire votre choix',
    hikingHint: 'Conduire 3 stations, marcher 1 station',
    selectDate: 'Choisissez votre date'
  },
  shortCutTrainReservation: {
    infoBox: 'Les réservations de train ne sont possibles que jusqu\'à 6h00 le jour de validité. Vous pouvez utiliser ' + 'd\'attente les jours de pointe.',
    chooseDate: 'Choisissez votre date'
  },
  shortCutTableReservation: {
    time: 'Choisissez l\'heure',
    selectTime: 'Veuillez choisir une heure',
    selectDate: 'Choisissez votre date'
  },
  selectMedium: {
    reduction: 'Choisissez une réduction',
    selectReduction: 'Avez-vous une carte de voyage AG ou demi-tarif?',
    selectTarifReduction: 'Vous êtes autochtone et possédez une carte d\'identité correspondante ?',
    isNotASwisspass: 'La carte choisie n\'est pas un Swisspass!',
    swisspassDataNotUpdated: ' Le Swisspass n\'a pas pu être vérifié.',
    swisspassHasNoGaOrHalfFare: 'Votre Swisspass n\'a pas de carte AG ou de demi-tarif valide.',
    swisspassHasNoGA: 'Votre Swisspass n\'a pas d\'AG valide',
    swisspassHasNoHalfFare: 'Votre Swisspass n\'a pas de carte demi-tarif valide',
    productForPerson: '{product} pour {person}',
    completeBirthdate: 'Veuillez compléter la date de naissance',
    preparingBasket: 'Votre panier est en cours de préparation. C\'est sur le point de continuer.',
    customBellwaldLocalNotification: 'Le tarif résident n\'est appliqué que sur présentation de la carte bleue officielle. ' + '(ou une attestation de résidence). Elle doit être délivrée après le 1er septembre de l\'année en cours.',
    customChaeserruggLocalNotification: 'Les habitants de la commune de Wildhaus - Alt St. Johann bénéficient d\'un ' + 'Tarifs spéciaux. Par la présente, vous confirmez que vous êtes en possession d\'une carte de résident de la commune valable. ' + 'Johann et être en mesure de le présenter sur demande.',
    customMoosalpregionLocalNotification: 'Par la présente, vous confirmez que vous êtes domicilié(e) dans le canton du Valais ' + 'et, dans le cas d\'un échantillon, être en mesure de le prouver au moyen de l\'attestation de résidence.',
    customMoosalpregionGuestNotification: 'Je confirme que je suis en possession d\'une carte d\'hôte valable et que ' + 'puisse les présenter à tout moment. Des contrôles aléatoires peuvent être effectués.',
    nonRefundable: 'frais de carte'
  },
  productsOverview: {
    editProducts: 'Modifier des produits',
    edit: 'modifier'
  },
  singleProductView: {
    editProduct: 'Modifier le produit',
    vat: 'TVA',
    capacity: 'Capacités',
    editCapacity: 'Modifier les capacités',
    capacityCalendar: 'Aperçu des capacités',
    productImage: 'Image du produit',
    selectAProductImage: 'Choisis une image',
    maxImageSize: 'Taille maximale 1MB',
    uploadingFailed: 'Échec du téléchargement',
    uploadingImage: 'Charger une photo ...',
    imageDescription: 'Format recommandé de 3: 2. Les formats autorisés sont .jp (e) g et .png',
    simpleProductImage: 'Image simple',
    productDefImage: 'Plusieurs photos',
    chooseProdDef: 'Choisissez la caractéristique du produit',
    productPresentation: 'Présentez le produit',
    productOverall: 'Produit en général',
    productCharacteristics: 'Caractéristiques du produit',
    bookableDates: 'La disponibilité des produits',
    activeAfterNextPriceCalculation: 'Remarque: Les paramètres ne deviendront actifs qu\'avec le prochain calcul de prix.',
    activate: 'Publier un produit',
    deactivate: 'Désactiver le produit',
    productIsDeactivated: 'Le produit est actuellement inactif et n\'est donc pas disponible dans la boutique.',
    errorUpdatingActive: 'Erreur lors de la mise à jour du statut',
    additionalProductHasNoCapacities: 'Le produit de comparaison n\'a pas défini de capacités'
  },
  productCapacity: {
    mapCapacityOnAttributes: 'Propriété du produit',
    mapCapacityOnProduct: 'Produit',
    capacityAmount: 'Capacité',
    addCapacityAmount: 'Entrez la capacité',
    capacityForProduct: 'Capacité quotidienne maximale pour le produit {produit}',
    deleteAllCapacities: 'Supprimer les capacités',
    reallyDelete: 'Vraiment supprimer?',
    allCapacitiesWillBeDeleted: 'Toutes les capacités de ce produit seront supprimées. Cette action ne peut pas être annulée!',
    editCapacity: 'Modifier la capcité',
    capacityUpdatedSuccessfully: 'Modifications sauvegardés.',
    capacityDeletedSuccessfully: 'Capacité supprimée',
    capacityCreatedSuccessfully: 'Capacité créée',
    capacitySpecification: 'Propriété du produit',
    selectCapacitySpecification: 'Choisissez une propriété de produit',
    attributeValue: 'Valeur',
    selectAttributeValue: 'Bitte wähle einen Wert aus',
    capacityForAttribute: 'Capacité maximale pour "{attributeValue}"',
    capacityAttributeWrong: 'Les paramètres de capacité ne correspondent pas aux valeurs du moteur de tarification. ' + 'Cela entraîne des indications erronées dans l\'ensemble de l\'application.'
  },
  capacityCalendar: {
    overrideCapacity: 'Remplacez la capacité maximale pour {attribueOuProduit}.',
    selectOverrideCapacity: 'Changer la capacité',
    selectEditEvent: 'Modifier l\'événement',
    startDateRequiredSmaller: 'La date de début doit être antérieure à la date de fin!',
    override: 'Écraser',
    whatDoYouWantToDo: 'Que voulez-vous faire?',
    showCapacitySibling: 'Afficher le produit de comparaison',
    disableCapacitySibling: 'Cacher le produit',
    showRuleBased: 'Afficher d\'autres options',
    hideRuleBased: 'Afficher moins',
    newCapacity: 'Nouvelle capacité maximale pour la sélection',
    showAll: 'Tout afficher'
  },
  valueCapacity: {
    updateCapacity: 'Écraser la capacité',
    capacityUpdated: 'Capacité mise à jour',
    capacityNotUpdated: 'La capacité n\'a pas pu être mise à jour.'
  },
  personAdder: {
    checkForAvailability: 'Nous vérifions la disponibilité.',
    availableTickets: 'Vendu | Encore 1 disponible | Encore {stockLeft} disponibles',
    soldOut: 'Offre épuisée. Malheureusement, aucun autre billet n\'est disponible.',
    ticketsSoldOutRemoved: 'Malheureusement, le billet souhaité n\'est plus disponible.',
    noFreeTable: 'Il n\'y a pas de table disponible pour cette heure, choisissez une autre heure.',
    selectAttribute: '{attribute} sélectionner',
    basketConditions: {
      min: 'Ajoutez {attributeTitle} au maximum {count}x au panier.',
      max: 'Ajoutez {attributeTitle} au moins {count}x au panier.'
    }
  },
  shopComment: {
    textFieldLabel: { trainRideNiesen: 'Commentaires ou demandes à transmettre à l\'équipe Niesen' },
    adminNote: {
      trainRideNiesen: 'La disponibilité des places ne peuvt être garantie.',
      tableReservation: 'La montée dure 30 minutes, les demandes de place ne peuvent pas être garanties.'
    },
    maxCharacter: 'Un maximum de 240 caractères est autorisé.'
  },
  product: {
    bookingOnlyTill: 'Réservation impossible. La réservation doit être effectuée par {réservation jusqu\'à} au plus tard. Veuillez choisir une date ultérieure.',
    callForBooking: 'Réservation en ligne uniquement possible jusqu\'à {bookingTill} heure. Pour les réservations à court terme, veuillez appeler le {phoneNumber}',
    eventsCouldNotBeLoaded: 'Les événements n\'ont pas pu être chargés.',
    loadingEvents: 'Les événements se chargent',
    failedLoadingAdditionAttr: 'Les attributs n\'ont pas pu être chargés',
    loadingValidityDates: 'Obtenez la disponibilité des produits',
    updatingValidityDates: 'Mettre à jour la disponibilité des produits',
    errorUpdatingValidityDates: 'Échec de la mise à jour de la disponibilité des produits',
    updatedValidityDates: 'La disponibilité des produits a été ajustée avec succès',
    sureToUpdate: 'Voulez-vous vraiment mettre à jour la disponibilité des produits?',
    noBookingDateLeft: 'Le produit est épuisé jusqu\'à la fin de la saison!',
    pricesCouldNotBeLoaded: 'Les prix n\'ont pas pu être chargés.'
  },
  shortCutHotel: { chooseArrivalDate: 'Choisissez la date d\'arrivée' },
  stepperModal: { niesen: { seatReservationModalText: 'Les places dans le funiculaire sont limitées. ' + 'Avec une réservation du funiculaire, nous vous garantissons une place dans le funiculaire à l\'heure choisie.\n' + '<br>Si vous avez fait une réservation du funiculaire, nous vous demandons de vous présenter ' + '<b>à l\'entrée</b> du groupe avec votre <b>réservation</b> (imprimée ou sur votre téléphone portable) ' + '<b>au moins 10 minutes avant</b> le départ du funiculaire réservé.\n' + '<br>Dans le cas contraire, nous ne pouvons pas garantir la réservation du funiculaire. \n' + '<br>Veuillez noter que vous aurez besoin d\'un <b>billet ordinaire</b> en plus de votre réservation.\n' } },
  hotelRoomSelector: {
    moreInformation: 'Plus d\'information',
    addToBasket: 'Ajouter au panier',
    roomAddedSuccessfully: 'Chambre ajoutée.',
    moreDetails: 'Plus d\'information'
  },
  singleEventView: {
    editEvent: 'Evénement modifié',
    createEvent: 'Evénement crée',
    eventTemplate: 'Modèle d\'événement',
    selectEventTemplate: 'Veuillez choisir un modèle d\'événement.',
    eventDate: 'Date de l\'événement',
    selectEventDate: 'Veuillez choisir une date d\'événement',
    eventTitle: 'Titre',
    eventLead: 'Brève description',
    eventDescription: 'Description détaillée',
    eventTitleRequired: 'Veuillez insérer un titre.',
    eventLeadRequired: 'Veuillez écrire une brève description.',
    eventDescriptionRequired: 'Veuillez décrire le produit.',
    removeEventFromShop: 'Supprimer l\'événement de la boutique',
    publishEvent: 'Enregistrer et publier',
    eventIsPublished: 'Votre événement est publié,vous pouvez le retrouvé dans la boutique en ligne',
    eventIsUnpublished: 'Votre événement n\'est pas publié et n\'est pas visible dans la boutique en ligne.',
    eventStartTime: 'Début de l\'événement',
    eventEndTime: 'Fin des événements',
    eventStartMandatory: 'Veuillez entrer l\'heure de début.',
    eventEndMandatory: 'Veuillez entrer l\'heure de fin.',
    timeIncomplete: 'Veuillez saisir l\'heure au format hh: mm.',
    editDescription: 'Description de l\'évenement',
    editPricing: 'Tarification',
    selectEventImage: 'Sélectionnez une photo pour l\'événement',
    eventImage: 'Photo de l\'événement',
    presentEvent: 'Décrivez l\'événement',
    eventData: 'Dates de l\'événement',
    iconText: 'Texte de l\'icône',
    iconTextRequired: 'Veuillez saisir un texte d\'icône.',
    iconRequired: 'Veuillez sélectionner l\'icône',
    iconsTitle: 'Icônes',
    noIcons: 'Pas d\'icônes en cours d\'utilisation',
    eventNotDeleted: 'L\'événement n\'a pas pu être supprimé, car il a déjà été enregistré.',
    deleteEvent: 'Supprimer un événement',
    reallyDeleteHeader: 'Supprimer vraiment l\'événement ?',
    reallyDeleteText: 'Cette suppression ne peut pas être annulée. L\'événement ne peut pas être restauré.',
    overrideTime: 'Modifier l\'heure',
    reallyOverrideTime: 'Changer vraiment le temps ?',
    explainTimeChange: 'Les invités qui ont déjà réservé l\'événement ne seront PAS informés du changement d\'horaire.'
  },
  event: {
    faildToCreate: 'L\'événement n\'a pas pu être créé.',
    eventCouldNotBeLoaded: 'L\'événement n\'a pas pu être chargé.',
    createdNewEvent: 'L\'événement a été créé',
    eventNotUpdated: 'Les modifications n\'ont pas pu être enregistrées.',
    eventUpdated: 'Les modifications ont été enregistrées.'
  },
  events: { eventsCouldNotBeLoaded: 'Les événements n\'ont pas pu être chargés.' },
  entityTranslation: { entityNotCreated: 'La traduction n\'a pas pu être enregistrée.' },
  createBookingOverview: {
    createNewBooking: 'Réserver',
    cancelBooking: 'Annuler la réservatio',
    atLeasOneBasketEntryRequired: 'Vous devez ajouter au moins un produit au panier.',
    confirmAndBook: 'confirmer la réservation',
    bookingConfirmation: 'Confirmation de réservation',
    customerPayed: 'Votre réglement a bien été encaissé!'
  },
  createBooking: {
    selectProductOrEvent: 'Produuit et événement',
    availableCapacity: 'Capacités',
    amountOfProducts: 'Nombre de produits',
    composeProduct: 'Choisissez la date et le produit',
    selectPerson: 'Sélectionnez le client principal',
    addToBasket: 'Ajouter au panier',
    productOrEventMandatory: 'Sélectionnez un produit ou un événement.',
    amountMandatory: 'Veuillez entrer un nombre.',
    productOrEventShort: 'Produit/Evènement',
    insufficientCapacities: 'La capacité est insuffisante. Vous pouvez augmenter les capacités pour cette journée ou vous inscrire sur la liste d\'attente sans engagement.',
    waitingList: 'Mettre la réservation sur la liste d\'attente',
    noSuchProductCombination: 'Cette combinaison de produits n\'existe pas! Veuillez ajuster les détails du produit.',
    incl: 'Inclus',
    changeBooking: 'La réservation doit-elle être effectuée auprès d\'un autre client principal? Vous devez ensuite vider le panier ou créer une nouvelle réservation.',
    hint: 'Conseil: vous pouvez attribuer les billets individuels à un autre utilisateur dans le panier ci-dessous.',
    productDetails: 'Produit/Détails',
    productSoldOut: 'Le produit est entièrement réservé pour ce nombre de personnes.',
    selectProduct: 'Sélectionner un produit',
    dateNotAvailableForSelectedProduct: 'Nous avons automatiquement adapté la date.',
    eventNotAvailableOnThisDate: 'L\'événement n\'est pas disponible à cette date !',
    saveChanges: 'Enregistrer la modification'
  },
  bookingByCustomerSearch: {
    userHasBookings: '{user} n\'a pas encore de réservations. | {user} a déjà {bookings} réservations. Spectacle. | {user} a déjà {booking} réservation. Spectacle.',
    hideBookings: 'Masquer les réservations',
    unpaid: 'non payé'
  },
  bookingConfirmation: {
    arrivalTime: 'Heure d\'arrivée (approximative)',
    bookingStateMandatory: 'Veuillez choisir un statut de réservation',
    sendMail: 'Envoyer la confirmation de réservation',
    doNotSendMail: 'Aucune confirmation de réservation',
    internalRemark: 'Commentaire (interne)',
    selectPerson: 'Choisissez une personne',
    thisIsTheBookingPerson: 'La réservation est sur cette personne',
    confirmationForThisPerson: 'Une confirmation par courrier sera envoyée à cette personne.',
    bookingUser: 'Réservation pour',
    mailRequired: 'Il manque l\'email de la personne sélectionnée.'
  },
  sTextEditor: { contentRequired: 'Veuillez saisir un texte pour la confirmation de réservation.' },
  adminCheckout: {
    checkoutFailed: 'Malheureusement, la réservation n\'a pas pu être effectuée!',
    sendingMailFailed: 'Malheureusement, la confirmation de réservation n\'a pas pu être envoyée.',
    bookingCreated: 'La réservation a été créée.',
    confirmationMailSent: 'La confirmation de réservation a été envoyée.',
    capacitySoldOut: 'Quelqu\'un vous a devancé. Un de vos produits a été épuisé entre-temps. La réservation n\'a pas été créée !',
    productInactive: 'Un des produits du panier a été rendu inactif entre-temps et ne peut donc plus être réservé.'
  },
  bookingState: {
    change: 'Changer le statut',
    changeBookingState: 'Voulez-vous changer le statut de la réservation?',
    undoImpossible: 'Attention: cette modification ne peut pas être annulée!',
    stateChanged: 'Statut de réservation modifié'
  },
  bookingStates: { stateCouldNotBeChanged: 'Le statut n\'a pas pu être modifié. La limite de capacité est peut être dépassée.' },
  paymentDetails: {
    customerPaid: 'Client a payé',
    didCustomerPaid: 'Le montant est-il encaissé?',
    amountReceived: 'La quantité de <span class = "font-weight-black"> {amount} </span> a été collectée.',
    changeBookingStateFirst: 'Modifiez le statut de réservation pour collecter le montant!',
    printGroupReceipt: 'Bon de groupe',
    groupDiscounts: 'Remise de groupe',
    payCashFromShopForbidden: 'Réservation de boutique non payée'
  },
  groupReceipt: {
    groupReceipt: 'Bon de réservation',
    peopleCount: 'Nombre de personnes: {peopleCount}',
    group: 'Groupe'
  },
  printTickets: {
    printTickets: 'Imprimer les billets',
    valid: 'Valide',
    barcodeError: 'Erreur: le code-barres n\'a pas pu être généré.',
    reason: 'Raison',
    novatouchError: 'Erreur Novatouch',
    co2Compensation: 'Compensation des émissions de CO2',
    cwcExplanation: 'Plus d\'informations sur causewecare.ch',
    bookingNumber: 'N° d\'écriture {bookingNumber}',
    niesenReservationHint: 'Veuillez vous rendre à l\'entrée du groupe 10 minutes avant le départ (respecter la signalisation). ' + 'Notez que vous avez également besoin d\'un billet de train régulier.'
  },
  priceBulkManagement: {
    gotoBtn: 'Remplacer les prix',
    editRules: 'Définir les règles',
    surcharge: 'Pourcentage',
    absoluteSurcharge: 'Prix absolu',
    chooseProducts: 'Sélectionner les produits',
    surchargeModeAbs: 'Remplacer les produits sélectionnés par un montant absolu',
    surchargeModePerc: 'Surcharge en pourcentage',
    amount: 'montant',
    percent: 'Pourcent',
    resetPrices: 'Réinitialiser les prix',
    reset: 'Réinitialiser',
    submit: 'Appliquer',
    repeat: 'Répéter',
    repeatEvery: 'Répéter tous les ',
    daily: 'Journalier',
    weekly: 'hebdomadaire',
    monthly: 'Mensuel',
    preview: 'Aperçu',
    explanation: 'L\'explication peut être ajustée et remplacée manuellement.',
    youAreOverriding: 'Modifier les prix',
    overwritePrice: 'Modifier les prix',
    youOverridePrices: 'Vous êtes sur le point de modifier les prix suivants',
    priceChange: 'Modifier les prix',
    absoluteChange: 'Nouveau prix pour tous les produits sélectionnés',
    priceReset: 'Le prix est réinitialisé à sa valeur par défaut pour tous les produits.',
    atDates: 'Aux dates',
    resetPricesTitle: 'Prix réinitialisés',
    youResetPrices: 'Vous êtes sur le point de réinitialiser les prix',
    repeatEveryWeekday: 'Recommencer chaque jour',
    overwrite: 'Écraser',
    failedOverwriting: 'Impossible de modifier les prix',
    failedReverting: 'Impossible de réinitialiser les prix',
    failedLoadingCustomPrices: 'Échec du chargement des prix',
    successOverridePrices: 'Suppression des prix réussie',
    successResetPrices: 'Réinitialisation des prix réussie',
    newPrice: 'Nouveau prix',
    oldPrice: 'Ancien prix',
    priceDifference: 'Différence',
    calculating: 'Calculez les prix, cela peut prendre un moment ...',
    product: 'Produit',
    filter: 'Filtrer par produit...',
    overrideWithZero: 'Attention. Le prix sera écrasé par 0. Vous êtes sûr de continuer?'
  },
  shopBookingCalendar: {
    selectProducts: 'Choisissez des produits',
    others: 'autres'
  },
  shopOverview: {
    noProductDefinitionProvided: 'Malheureusement, aucun produit approprié n\'a pu être trouvé.',
    scrollHint: 'Faire défiler pour afficher plus d\'expériences',
    groupRequests: 'Demandes de groupe'
  },
  bookingComplete: {
    excelDownload: 'Exporter la liste',
    bookings: 'Réservations',
    people: 'Personnes'
  },
  datePersonCarousel: {
    available: '{Capacities} encore disponibles',
    selectAmountOfPeople: 'Sélectionnez le nombre de personnes',
    loadingSelection: 'Veuillez patienter...',
    maxAvailableTickets: 'Sièges épuisés | Max 1 siège disponible | Max {stockLeft} sièges disponibles',
    availableTickets: 'Sièges épuisés | 1 siège disponible | {stockLeft} sièges disponibles'
  },
  basket: {
    peopleCount: '{peopleCount} personne | {peopleCount} personnes',
    sledgeCount: '{peopleCount} luge | {peopleCount} luges',
    dogCount: '{peopleCount} chien | {peopleCount} chiens',
    checkout: 'Veuillez régler',
    addBasketEntries: 'Mettez vos produits souhaités dans le panier.',
    causeWeCareNotUpdated: 'Malheureusement, la Compensation-CO2 n\'a pas pu être ajoutée.',
    inclCo2Compensation: 'Inclus la Compensation-CO2',
    causeWeCare: 'Cause We Care',
    add: 'Ajouter',
    requiredEntryCannotBeDeleted: 'Ce produit ne peut pas être supprimé car il appartient à un autre produit du panier.',
    offered: 'Offert',
    nonRefundableCardFee: 'y compris {fee} frais de carte'
  },
  productPresenter: {
    start: 'Démarrer',
    end: 'Fin',
    unfold: 'Plus d\'informations',
    fold: 'Moins d\'informations',
    jumpToDate: 'Choisissez une date'
  },
  productCategories: {
    train: 'Voyage en train',
    tableReservation: 'Réserver une table',
    gastro: 'Offre Gastronomique',
    events: 'Modèles d\'événement',
    rooms: 'Séminaires et célébrations',
    required: 'Requis',
    hotel: 'Hotel & Nuitée',
    request: 'Demande',
    requestForm: 'Demandes de groupe',
    niesenExclusive: 'Exclusif',
    reservation: 'Réservations',
    seasonabo: 'Abonnements de saison',
    voucher: 'Bons d\'achat',
    ski: 'Ski',
    singlerides: 'Trajets individuels',
    crowdFunding: 'Crowdfunding',
    winterabo: 'Carte saison hiver',
    winterAbo: 'Cartes saison hiver',
    summerabo: 'Summer pass',
    yearabo: 'Cartes annuelles',
    pistenBully: 'Alpuschnaager',
    points: 'Cartes à points',
    sledge: 'Billets de luge',
    pedestrian: 'Piétons',
    hiking: 'Billets de randonnée',
    bikepark: 'Parc à vélos',
    summerOffers: 'Offres estivales',
    experiences: 'Expériences',
    winteraboSki: 'Forfaits de ski d\'hiver',
    yearaboPedestrian: 'Abonnements annuels pour piétons',
    sendingcostPerBooking: 'Frais d\'envoi',
    insurance: 'Assurance',
    transportInPackage: 'Transport',
    printse: 'Printse',
    '4_vallées': '4 Vallées',
    fee: 'Frais d\'envoi',
    summeraboNendaz: 'Abos saison été',
    winteraboSkiNendaz: 'Abos annuels (hiver + été 2023)',
    yearaboPedestrianNendaz: 'Abo piéton (hiver + été 2023)',
    royalrides: 'Royal Ride',
    promotions: 'Promotion'
  },
  adminBasket: {
    groupDiscount: 'Remise',
    createGroupDiscountFailed: 'La remise de groupe n\'a pas pu être créée.',
    discountType: 'Type de remise',
    discountDescription: 'Description de la remise',
    selectDiscountType: 'Choisissez le type de remise',
    provideDiscountDescription: 'Pourquoi la remise?',
    insertDiscountAmount: 'Quel devrait être la remise?',
    couldNotDeleteGroupDiscount: 'La remise de groupe n\'a pas pu être supprimée.',
    netWithoutVat: 'Hors Taxe.',
    vat: 'TVA',
    totalInclVat: 'TTC',
    incl: 'Inclus',
    withCauseWeCare: 'Avec la Compensation-CO2',
    withoutCauseWeCare: 'Sans la Composition CO2',
    fetchingBasketFailed: 'Le panier n\'a pas pu être chargé.',
    addProduct: 'Ajouter un produit',
    saveChanges: 'Enregistrer les modifications'
  },
  discountTypes: {
    absolute: 'Absolue (CHF)',
    // not in use
    relative: 'Relative (%)'
  },
  contactForm: {
    yourMessage: 'Votre message',
    messageRequired: 'Veuillez décrire votre demande'
  },
  sendRequest: {
    summary: 'Sommaire',
    sendRequest: 'Envoyer votre demande',
    request: 'Demande',
    senderContact: 'Contact de l\'expéditeur :'
  },
  formRequest: {
    sendingFailed: 'Votre message n\'a pas pu être envoyé',
    requestSent: 'Votre message nous a bien été transmis.'
  },
  bookingsComplete: { roomNumber: 'Numéro de chambre' },
  bookingEntry: { saveAllocationNumberFailed: 'Le numéro alloué n\'a pas pu être enregistré.' },
  checkoutNavigation: {
    compensateCo2: 'Compenser le CO2',
    payNow: 'Payez maintenant',
    capacitySoldOut: 'Quelqu\'un vous a devancé. Un de vos produits a été épuisé entre-temps. ' + 'Votre réservation n\'a pas pu être finalisée. Votre compte n\'a pas été débité.',
    productInactive: 'L\'un des produits du panier n\'est malheureusement plus disponible.',
    accommodationTax: 'Veuillez payer la taxe de séjour/la taxe d\'hébergement à l\'auberge.',
    voucherNotValidated: 'Le bon d\'achat que vous avez indiqué n\'a pas encore été ajouté. Ajoutez-le ou ' + 'ou l\'enlever pour continuer.',
    niesen: {
      oldVoucherTitle: 'Échanger l\'ancien bon Niesen - en toute simplicité',
      oldVoucherText: 'Pour pouvoir utiliser un ancien bon (voir photo) en ligne, vous pouvez utiliser le code QR (voir cadre rouge sur la photo) avec un ' + 'Scanner la caméra du téléphone portable. La caméra du téléphone portable vous donnera un code ' + 'photo) avec l\'appareil photo d\'un téléphone portable. L\'appareil photo du téléphone portable affiche ' + 'un code. Vous pouvez transférer ce code dans le champ ci-dessus ("Enter online credit code"). ' + '<b>Le numéro de réservation imprimé ne peut pas être saisi en ligne</b>'
    }
  },
  imageUploader: {
    required: 'Un fichier doit être sélectionné',
    wrongFileType: 'Seulement possible avec.png et .jpg'
  },
  singleReport: {
    noContent: 'Pas de contenu',
    roomNumber: 'Numéo de chambre',
    details: 'Détails',
    total: 'Total',
    peopleOverAll: 'Personnes (chaque fois)',
    totalPeople: 'Personnes',
    reservations: 'Réservations',
    events: 'événements',
    event: 'événement',
    groups: 'Groupes',
    product: 'Prestation de service',
    maxPlaces: 'Numéro réservé/maximum',
    noLimitation: 'Aucune limite',
    tel: 'Tél.'
  },
  extendedAttribute: { saveFailed: 'L\'enregistrement a échoué' },
  salutation: {
    m: 'Monsieur',
    f: 'Madame'
  },
  settingsOverview: {
    manageRoles: 'Gérer les rôles',
    productsImport: 'Importation de produits',
    changeCurrency: 'Changer la monnaie',
    axessSeasonCreation: 'Initialiser une nouvelle saison chez Axess',
    powerBi: 'Gérer les Power BI'
  },
  powerBiManagement: {
    noDataAvailable: 'Il n\'y a pas de Power BI pour cette région.',
    connectPowerBis: 'Quel rôle peut voir quel BI ?',
    editPowerBis: 'Créer une BI'
  },
  UsersRoles: { couldNotBeLoaded: 'Ne peux pas être chargé' },
  roleManagement: {
    user: 'Utilisateur',
    role: 'rôle',
    addNewRole: 'Ajouter de nouveau rôle',
    userAlreadyAdded: 'L\'utilisateur sélectionné a déjà attribué des rôles. Vous pouvez trouver son nom en haut de la liste.'
  },
  roles: {
    couldNotBeLoaded: 'Les rôles n\'ont pas pu être récupérés.',
    couldNotBeLinked: 'Le rôle n\'a pas pu être ajouté à l\'utilisateur!',
    couldNotBeDeleted: 'Le rôle n\'a pas pu être supprimé de l\'utilisateur!'
  },
  shopHandler: { shopClosed: 'La boutique en ligne est actuellement fermée.' },
  paymentTotalListing: {
    taxNr: 'Numéro de TVA',
    cancelledServices: 'Services annulés'
  },
  bookingAggregated: { noCapacityLimit: 'Aucune limite de capacité' },
  pricingOverridePrices: { notInValidityDates: 'Le produit n\'est pas disponible pour tous les jours que vous avez sélectionnés. Les jours non disponibles sont ignorés lors de l\'écrasement du prix !' },
  eventSection: { knowMore: 'En savoir plus' },
  sectionTitle: {
    events: 'Événements uniques',
    customService: 'Offres sur mesure',
    extraordinaryExperiences: 'Expériences extraordinaires en montagne',
    requests: 'Demandes'
  },
  bookingPaid: { backToCashDesk: 'Retour à la caisse' },
  fontAwesomeSelect: { selectLabel: 'Icône' },
  appHeader: {
    goToBackendShop: 'Dans le backend de la boutique',
    goToBackendPe: 'Vers le moteur de tarification'
  },
  translationIcons: { addIcon: 'Ajouter une icône' },
  fileUploadService: {
    processingExcel: 'Les produits sont importés. Cela peut prendre un certain temps.',
    importSucceed: 'L\'importation de produits a été un succès !'
  },
  productsImport: {
    fileInputLabel: 'Sélectionnez Excel',
    required: 'Veuillez sélectionner un fichier Excel qui peut être importé.',
    wrongFileType: 'Seul le format de fichier .xlsx est pris en charge',
    upload: 'Télécharger',
    reallyImport: 'Écraser les paramètres du produit ?',
    importCannotBeUndone: 'Les produits et leurs propriétés sont irrémédiablement écrasés. Ce processus' + ' ne peut pas être annulée !',
    overwrite: 'Écraser',
    selectDestination: 'Choisissez une destination',
    wrongFileName: 'Le nom du fichier ne correspond pas au nom de la région.'
  },
  changeCurrency: {
    changeLable: 'Changer de monnaie',
    currency: 'Monnaie',
    currencyNotEmpty: 'Une devise doit être choisie.',
    changeSuccess: 'Le changement de monnaie a été effectué.'
  },
  reportsOverview: {
    bookings: 'Exportation comptabilité / Cause We Care',
    bookings_filename: 'Réservations_Cause_Nous_Care',
    cwc: 'CWC',
    accounting: 'Réservations',
    from: 'De',
    to: 'Jusqu\'à',
    required: 'Nécessite',
    export: 'Exportation',
    loadingDataFailed: 'Erreur lors du chargement des données CWC/écriture',
    idBooking: 'ID de l\'écriture totale',
    vat: 'TVA sur le CWC (7,7%)',
    cash: 'Caisse',
    six_saferpay: 'SIX',
    moreOrEquals: '"Jusqu\'à" doit être supérieur à "De".',
    lessOrEquals: '"De" doit être inférieur ou égal à "A".',
    noData: 'Aucune donnée dans la période sélectionnée',
    accountingHeaders: {
      bookingId: 'ID de l\'écriture totale',
      bundelId: 'ID du regroupement de produits',
      id: 'ID du produit individuel (au sein de la liasse)',
      product: 'Produit',
      productDefinition: 'Détails',
      customer: 'Client',
      mail: 'E-mail',
      start: 'Début de validité',
      end: 'Fin de validité',
      state: 'Statut comptable',
      paymentType: 'Mode de paiement',
      note: 'Remarque',
      currency: 'Monnaie',
      netPrice: 'Montant net',
      grossPrice: 'Montant brut',
      vat37: 'TVA 3,7',
      vat77: 'TVA 7,7',
      cancelAmount: 'Annulation',
      cancelDate: 'Date d\'annulation',
      clearedNetPrice: 'montant net ajusté',
      clearedGrossPrice: 'montant brut ajusté',
      clearedVat37: 'TVA ajustée 3,7',
      clearedVat77: 'TVA ajustée 7,7',
      bookingDate: 'Date de réservation',
      paymentTime: 'Délai de paiement'
    }
  },
  seatReservation: {
    stepperHeaderText: 'Réservation',
    earlier: 'plus tôt',
    later: 'plus tard',
    reserveNow: 'Réservez maintenant',
    seatsAvailable: 'Sièges disponibles',
    warningText: {
      niesen: 'Sans réservation, il peut y avoir des temps d\'attente les jours de pointe.',
      moosalpregion: 'Sans réservation de place, nous ne pouvons pas vous garantir une place assise à l\'Alpuschnaager.'
    },
    soldOut: {
      moosalpregion: 'Toutes les places sont vendues. Sans réservation, le trajet n\'est pas garanti et de longs temps d\'attente sont possibles.',
      niesenTooLate: 'Les réservations de train ne sont possibles que jusqu\'à 6h00 le jour de validité. Vous pouvez toutefois ' + 'des temps d\'attente les jours de pointe.',
      niesen: 'Plus aucune réservation de train n\'est possible pour la date choisie. Mais vous pouvez aussi utiliser ' + 'le train sans réservation. Sans réservation, il peut y avoir des temps d\'attente les jours de pointe.'
    },
    productTexts: {
      niesen: [
        'En haut',
        'En bas'
      ]
    },
    selectTime: 'Trouver l\'heure',
    inTo: 'Dans le',
    continueWithoutReservation: 'Continuer sans réservation',
    youWillRedirectedShortly: 'Vérifiez les réservations. Vous serez redirigé sous peu.',
    nextStepAnyway: 'Continuer quand même'
  },
  products: {
    overrideFailed: 'Les capacités n\'ont pas pu être modifiées.',
    capacitiesOverriden: 'Les capacités ont été modifiées.',
    capacityOverrideTakesAWhile: 'Les capacités sont écrasées. Cela peut prendre plusieurs minutes.',
    archive: 'Archives'
  },
  capacityOverride: {
    noDatesSelected: 'Sélectionnez les jours de la semaine dans le calendrier pour lesquels la capacité doit être modifiée.',
    setCapacityAmount: 'Saisir une nouvelle capacité.',
    noCapacitiesSelected: 'Sélectionner les capacités.',
    reallyChange: 'Changer vraiment les capacités ?',
    willBeOverwrittenOn: 'Aux dates suivantes'
  },
  capacityBellowWarning: { bellowWarning: 'Capacité sous Réservations' },
  shortCutSeasonAbos: {
    summer: 'Cartes de saison été',
    winter: 'Cartes de saison hiver',
    family: 'Cartes de saison familles',
    selectSeasonMandatory: 'Veuillez sélectionner le type d\'abonnement.',
    selectSeason: 'Choisir le type d\'abonnement',
    pointCards: 'Cartes à points'
  },
  shortCutSledge: { selectRoute: 'Choisir un parcours' },
  seasonAbos: {
    bookNow: 'Réserver maintenant',
    noProductAvailable: 'Pas de produit disponible à cette date.'
  },
  priceHistory: {
    viewTitle: 'Évolution historique des prix',
    timespan: 'Durée',
    sevenDays: 'Derniers 7 jours',
    fourteenDays: 'Derniers 14 jours',
    thirtyDays: 'Derniers 30 jours',
    seasonStart: 'Depuis le début de la saison',
    all: 'Tous',
    skiDay: 'Journée de ski',
    priceHistory: 'Historique des prix'
  },
  currentPostedPricesChart: {
    ylabel: 'Prix',
    lastCalcDate: 'Dernier calcul du prix'
  },
  dailyBaseRateChart: {
    ylabel: 'Taux de base quotidien en',
    overlayText: 'Taux de base quotidien :'
  },
  productTargetPriceChart: { ylabel: 'Prix cible du produit' },
  cashDeskPriceChart: { ylabel: 'Prix du comptoir de trésorerie' },
  multiDayDiscountChart: {
    ylabel: 'Prix cible du produit',
    overlayText: 'Taux de base quotidien : CHF',
    // not in use
    multiDayDiscountLabel: 'Multi Day Discount',
    productTargetPrice: 'Prix cible du produit',
    currentPostetPrice: 'Prix courant'
  },
  maxEarlyBookingChart: {
    ylabel: 'Prix courant',
    factorAxis: 'Réduction actuelle pour les réservations anticipées',
    priceAxis: 'Prix courant'
  },
  cashDaskPriceModal: {
    title: 'Prix du comptoir de trésorerie',
    currentPrice: 'Courant Cash Desk Price',
    difference: 'Variation',
    newPrice: 'Nouveau Cash Desk Price',
    min: 'Min Cash Desk Price',
    max: 'Max Cash Desk Prix'
  },
  baseOverwriteModal: {
    abort: 'Annuler',
    overwrite: 'écraser',
    notPossible: 'Le passé ne peut pas être édité.',
    overMaximum: 'Au dessus du maximum',
    belowMinimum: 'En dessous du minimum',
    reset: 'reset'
  },
  multiDayDiscountOverwriteModal: {
    title: 'Prix cible du produit',
    max: 'Max Multi-Day Discount',
    min: 'Min Multi-Day Discount',
    dailyBaseRate: 'Taux de base quotidien',
    multiDayDiscountFactor: 'Facteur d\'actualisation multi-jour',
    productTargetPrice: 'Prix cible du produit',
    valueAndDemandFactor: 'Facteur de valeur et de demande',
    currentPostedPrice: 'Prix courant',
    targetPriceTooLow: 'Le nouveau Current Posted Price est plus bas que le précédent. Valeur d\'origine: {val}',
    from: 'Jours de',
    infoBox: 'Les modifications du Target Price ne seront visibles qu\'après le prochain calcul de prix',
    noSlider: 'Le curseur n\'est pas disponible.',
    basicPriceOverview: 'Aperçu des prix de base',
    multiDayDiscount: 'Réduction pour plusieurs jours',
    multiDayDiscountFacotrHelp: 'Facteur de réduction sur plusieurs jours',
    roundDiff: 'Différence d\'arrondi'
  },
  dailyBaseRateOverwriteModal: {
    title: 'Daily Base Rate pour le',
    max: 'Max Daily Base Rate',
    min: 'Min Daily Base Rate',
    dailyBaseRate: 'Courant Daily Base Rate',
    change: 'Variation',
    newDailyBaseRate: 'Nouveau Daily Base Rate',
    infoBox: 'Les changements apportés au Daily Base Rate ne seront visibles qu\'après le prochain calcul de prix.',
    basicPriceOverview: 'Aperçu des prix de base',
    workload: 'Utilisation prévue:',
    notOkWithDailyBR: 'Vous n\'êtes pas satisfait du Daily Base Rate?'
  },
  earlyBookingOverwriteModal: {
    title: 'Prix actuel',
    max: 'Réduction Max Early Booking',
    min: 'Min Early Booking Discount',
    dailyBaseRate: 'Taux de base quotidien',
    earlyBookingFactor: 'Facteur de réduction Early Booking',
    productTargetPrice: 'Prix cible du produit',
    valueAndDemandFactor: 'Facteur de valeur et de demande',
    currentPostedPrice: 'Current Posted Price (avant l\'élément de structure)',
    cashDeskPrice: 'Prix du comptoir de trésorerie',
    targetPriceTooLow: 'Le nouveau Current Posted Price est inférieur au précédent. Valeur d\'origine: {val}',
    from: 'Jours de',
    infoBox: 'Les modifications du Current Posted Price ne seront visibles qu\'après le prochain calcul de prix.',
    noSlider: 'Le curseur n\'est pas disponible.',
    valDem: 'Valeur',
    currentEarlyBookingDiscount: 'Courant Early Booking Discount',
    realizedDemandFactor: 'Facteur de demande réalisé',
    timeFactor: 'Time Factor',
    multiDayDiscount: 'Facteur d\'actualisation multi-jour'
  },
  bookmarks: {
    title: 'Listes de favoris',
    newList: 'Nouvelle liste de favoris',
    noLists: 'Vous n\'avez pas créé de liste de favoris.',
    listName: 'Nom de la liste',
    create: 'Créer',
    required: 'Nécessite',
    maxChars: 'Nombre maximal de lettres atteint.',
    notUnique: 'liste existe déjà.',
    editLists: 'Modifier les favoris',
    abort: 'Annuler',
    back: 'Retour',
    removeList: 'Supprimer',
    noProdDefs: 'Aucune entrée',
    editListsTitle: 'Modifier les favoris',
    addListTitle: 'ajouter aux favoris',
    bookmarkFilter: 'Favoris'
  },
  realizedDemandChart: {
    overlayText: 'Nombre de ventes:',
    yAxisLabel: 'Demande réalisée'
  },
  crowdFunding: { title: 'Soutenez la construction du télésiège 6 places' },
  priceOverrideEvents: {
    selectProductDefinitions: 'Choisir les caractéristiques du produit',
    description: 'Expression',
    newPrice: 'Nouveau prix',
    newPriceRequired: 'Veuillez saisir un nouveau prix.',
    override: 'Écraser',
    noSelectedProductDefinitions: 'Sélectionnez au moins une caractéristique du produit.',
    noDateGiven: 'Erreur inattendue : pas de date'
  },
  // stepper header texts
  stepperHeader: {
    chaeserrugg: {
      componentLevel: {
        Basket: { modalContent: '<p><strong>Par âge</strong></p>\n' + '<p><strong>Adulte : </strong>à partir de 20 ans <br /> <strong>Senior :</strong> à partir de 65 ans <br /> <strong>Adolescent :</strong> 16 &ndash; 19 ans<br /> <strong>Enfant :</strong> 6 &ndash; 15 ans<br /> </p>\n' + '<p>F&uuml;r die Altersabgrenzung ist der erste G&uuml;ltigkeitstag des Tickets entscheidend.</p>\n' + '<p>&nbsp;</p>\n' + '<p><strong>Forfait ski journalier avec AG CFF</strong></p>\n' + '<p>Inhaber eines Generalabonnements der SBB erhalten rund 20% Reduktion auf die 1- und 2-Tagesskip&auml;sse. Dieser Rabatt kann bei der Personalisierung der Skitickets (sp&auml;ter im Buchungsprozess) ausgew&auml;hlt werden. Dabei muss das Skiticket allerdings zwingend auf den SwissPass geladen werden. <br /> </p>\n' + '<p><strong>Speziell f&uuml;r Familien</strong><br /> Familien profitieren von speziellen Konditionen f&uuml;r Kinder ab einem 3-Tagespass. Ein Familientarif kommt nur zur Anwendung, wenn der Kinderskipass mit mindestens einem Elternteil gel&ouml;st wird.</p>' },
        SeasonAbos: { modalContent: '<p><strong>Carte d\'hiver</strong></p>\n' + '<p><strong>Adulte : </strong>à partir de 20 ans <br /> <strong>Senior :</strong> &nbsp;cette catégorie n\'existe pas chez les abonnés <br /> <strong>Adolescent :</strong> 16 &ndash; 19 ans<br /> <strong>Enfant :</strong> 6 &ndash; 15 ans</p>\n' + '<p>Avec la carte d\'hiver, vous pouvez&ouml;profiter du domaine de Ch&auml;serrugg tout l\'hiver &nbsp;: le ski, la luge, le ski de fond, les randonnées hivernales ainsi que les parts de train lors des dîners de pleine lune et le ski nocturne sont inclus.</p>\n' + '<p>&nbsp;</p>\n' + '<p><strong>Carte hiver (lundi-vendredi)</strong></p>\n' + '<p><strong>Adulte : </strong>à partir de 20 ans <br /> <strong>Senior :</strong> &nbsp;cette catégorie n\'existe pas chez les abonnés <br /> <strong>Adolescent :</strong> 16 &ndash; 19 ans<br /> <strong>Enfant :</strong> 6 &ndash; 15 ans</p>\n' + '<p>Mit der Winterkarte Mo-Fr k&ouml;nnen Sie w&auml;hrend den Wochentagen von Montag bis Freitag das Ch&auml;serrugg Gebiet geniessen. An Wochenenden (Samstag und Sonntag) ist dieses Abonnement nicht g&uuml;ltig. Falls Sie trotzdem mal an einem Wochenende kommen m&ouml;chten, k&ouml;nnen Sie gerne eine Tageskarte dazu buchen.</p>\n' + '<p>&nbsp;</p>\n' + '<p><strong>Carte d\'hiver pour les familles</strong></p>\n' + '<p><strong>Adulte : </strong>à partir de 18 ans <br /> <strong>Enfant :</strong> jusqu\'à 17.99 ans</p>\n' + '<p>Als Familien profitieren Sie von der attraktiven Familienkarte. Im Preis der Familienkarte sind maximal 2 Erwachsene plus eine beliebige Anzahl Kinder im gleichen Haushalt lebend bis 17.99 Jahre inklusive. Der Stichtag f&uuml;r das Alter bei Winterkarten ist der Start des t&auml;glichen Betriebs der Bergbahnen (z.B. Start t&auml;glicher Betrieb am 15.12: Kinder, die bis zum 15.12. noch unter 16-Jahre alt sind, erhalten noch den Kinder-Tarif.)</p>' }
      },
      specificModuleComponentLevel: {
        hikingChaeserrugg: {
          SeasonAbos: {
            headerText: 'Informations sur les billets',
            modalTitle: 'Informations sur les billets',
            modalContent: '<p><strong>Catégories d\'âge</strong></p>' + '<p>Adulte : à partir de 16 ans</p>' + 'Enfants : 6 - 15 ans' + '<p>&nbsp;</p>' + '<p><strong>Réductions CFF AG et HTX</strong></p>' + 'Les réductions AG CFF et HTX peuvent être revendiquées lors du processus de paiement.' + '<p>&nbsp;</p>' + '<p><strong>Billet de randonnée</strong></p>' + 'Valable pour trois trajets sur l\'axe Unterwasser-Iltios-Chäserrugg. Par exemple, si vous prenez le train d\'Unterwasser à Iltios, que vous faites ensuite une randonnée jusqu\'au Chäserrugg et que vous revenez ensuite en train du sommet jusqu\'à Unterwasser.' + '<p>&nbsp;</p>' + '<p><strong>Billet Churfirsten</strong></p>' + '1 montée et 1 descente Unterwasser-Iltios ou Alt St. Johann-Sellamatt, 1 trajet en car postal entre Unterwasser et Alt St. Si vous prenez par exemple le train d\'Alt St. Johann à l\'Alp Sellamatt, que vous randonnez jusqu\'à Iltios et que de là vous prenez le funiculaire jusqu\'à Unterwasser.' + '<p>&nbsp;</p>' + '<p><strong>Carte journalière de randonnée</strong></p>' + 'Utilisation de toutes les remontées mécaniques de la région du Chäserrugg, y compris le car postal entre Unterwasser et Alt St. Johann. Si, par exemple, vous vous rendez d\'Alt St. Johann à l\'Alp Sellamatt, que de là vous faites une randonnée jusqu\'au Chäserrugg en passant par le Hinterrugg et que vous prenez ensuite le train du sommet jusqu\'à Unterwasser.' + '<p>&nbsp;</p>' + '<p><strong>Billet d\'exposition de textiles</strong></p>' + 'Le billet de randonnée pour l\'exposition de la STF au Chäserrugg donne droit à un voyage en train sur 3 trajets (un trajet est effectué à pied). Vous pouvez également utiliser ce billet pour une entrée gratuite au musée du textile de Saint-Gall, ainsi que pour un cours d\'initiation à la STF.'
          }
        },
        singleRideChaeserrugg: { Basket: { modalContent: '<p><strong>Par âge</strong></p>\n' + '<p><strong>Adulte : </strong>à partir de 16 ans <br /> <strong>Enfant :</strong> 6-15 ans <br /></p>\n' + '<p>Le premier jour de validité du ticket est déterminant pour la délimitation de l\'âge.</p>\n' + '<p>&nbsp;</p>\n' + '<p><strong>Réductions CFF demi-tarif et AG</strong></p>\n' + '<p>Les réductions sur les trajets individuels peuvent être réclamées plus tard lors du processus de paiement avec un AG ou un demi-tarif valable.</p>\n' } }
      }
    },
    bellwald: {
      componentLevel: {
        Basket: { modalContent: '<p>Adultes : à partir de 20 ans<br />' + 'Jeunes : de 16 à 19 ans<br />' + 'Enfants : de 6 à 15 ans<br />' + 'Enfants en bas âge : de 0 à 5 ans, le transport est GRATUIT à Bellwald. Disponible uniquement à la billetterie.</p>' + 'L\'âge applicable est celui au moment de l\'utilisation (1er jour de validité) <br><br>' + '<b>Forfait de ski transférable pour partenaire/marié avec enfants.</b> <br> Avec le forfait partenaire, une seule des deux personnes peut être sur les pistes à la fois.<br><br>' + '<b>Spécial familles</b> <br> Le 2e enfant bénéficie d\'une réduction allant jusqu\'à 20r, le 3e et les suivants d\'une réduction allant jusqu\'à 30r (valable uniquement pour les forfaits de ski de 3 jours). <br><br>' + '<b>Tarif pour les invalides</b> <br> Tarif réduit pour les accompagnateurs d\'invalides. Disponible uniquement à la billetterie. <br><br>' + '<b>Carte 4h</b> <br> Carte horaire avec une validité de 4 heures consécutives. Utilisable uniquement sur une journée de ski. Les heures restantes ne peuvent pas être utilisées le jour suivant.' },
        CrowdFunding: { modalContent: '<p>Leisten Sie einen freiwilligen G&ouml;nnerbeitrag zum Neubau der 6er Sesselbahn. Alle Infos zum Projekt finden Sie hier: <a class="sc-dPPMrM bBscpx" title="http://www.bellwald.ch/support" href="http://www.bellwald.ch/support" target="_blank" data-renderer-mark="true"><strong data-renderer-mark="true">ww.bellwald.ch/support</strong></a></p>' },
        StandardCalendar: {
          headerText: 'Choisissez votre date de début',
          modalTitle: 'Choisir les dates qui conviennent',
          modalContent: 'Choisissez les dates qui vous conviennent pour profiter du ski. Vous pouvez choisir de 1 à 14 jours maximum. Vous pouvez modifier la durée dans la liste.'
        },
        SeasonAbos: { modalContent: 'Les invités qui achètent leur abonnement en premier reçoivent un bon d\'achat en plus de l\'abonnement. ' + 'de leur choix. Qu\'il s\'agisse d\'une carte journalière de ski pour des amis, de bons de valeur des remontées mécaniques ou d\'un bon de ' + 'la boutique de sport. Attention, les bons ne sont disponibles qu\'en nombre limité. <br><br>' + 'Le <b>forfait de ski partenaire</b> pour partenaire/époux est transmissible entre eux. Il peut toutefois être utilisé respectivement ' + 'ne peut être utilisé que par une seule personne. Le transfert à d\'autres personnes que le partenaire/conjoint est exclu.<br><br>' + '<b>Adulte</b>: 20 ans ou plus<br>' + '<b>Adolescent</b>: 16 - 19 ans<br>' + '<b>enfant</b>: 6 - 15 ans<br>' + '<b>Partenaire</b>: 20 ans ou plus<br>' + '<b>Les enfants en bas âge</b> reçoivent un ticket de ski gratuit au guichet' }
      }
    },
    moosalpregion: {
      componentLevel: {
        Basket: { modalContent: '<b>Adultes</b>: nés en 1999 et avant <br>' + '<b>Jeunes</b>: nés de 2000 à 2004 <br>' + '<b>enfants</b>: nés de 2005 à 2011 <br>' + '<b>Petits enfants</b>: nés en 2012 et plus jeunes <br>' + '<br><br>' + '<b>Spécialement pour les familles</b> <br>' + 'Les familles bénéficient d\'un rabais familial de 5% si min. 1 adulte ' + '(max. 2 personnes adultes) en combinaison avec au moins deux enfants payants (catégorie enfant ou ' + 'jeunes) peuvent être achetés.' },
        SeasonAbos: { modalContent: '<b>Adultes</b>: nés en 1999 et avant <br>' + '<b>Jeunes</b>: nés de 2000 à 2004 <br>' + '<b>enfants</b>: nés de 2005 à 2011 <br>' + '<b>Petits enfants</b>: nés en 2012 et après <br><br>' + '<b>Durée de validité des cartes à points :</b> 2 ans à partir de la date d\'achat <br><br>' + '<b>Évaluation des cartes de score</b><br>' + '<table style="border-collapse: collapse;" border="solid"><tbody><tr>' + '<td width="201">Ascenseur</td>' + '<td width="152">adulte / adolescent</td>' + '<td width="138">enfant</td>' + '</tr><tr>' + '<td width="201">Téléski pour enfants Bodmen</td>' + '<td width="152">1</td>' + '<td width="138">1</td>' + '</tr><tr>' + '<td width="201">Ascenseur à feuilles</td>' + '<td width="152">2</td>' + '<td width="138">1</td>' + '</tr><tr>' + '<td width="201">télésiège</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr><tr>' + '<td width="201">Ronalplift</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr><tr>' + '<td width="201">Ascenseur de sous-conseil</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr><tr>' + '<td width="201">Moosalplift</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr><tr>' + '<td width="201">T&ouml;rbeltallift</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr></tbody></table>' },
        StandardCalendar: { modalContent: 'Choisissez les dates qui vous conviennent pour profiter du ski. Vous pouvez adapter la durée dans la liste.' },
        PerformanceDifferentiation: { modalContent: 'Avec le tarif <b>Basic</b> , vous achetez un forfait de ski qui ne peut être ni modifié ni échangé. ' + 'peut être annulée. Le billet de ski n\'est valable que pour la date choisie.' + '<br><br>' + 'Avec le tarif <b>Flex</b> , vous achetez un forfait de ski qui peut être modifié de manière flexible. Vous pouvez ' + 'annuler le billet jusqu\'à <b>23:59</b> heures avant le 1er jour de validité. En cas d\'annulation, la totalité du ' + 'Réservation annulée. Il n\'est pas possible d\'annuler des journées de ski individuelles d\'un billet de plusieurs jours. ' + 'Dans ce cas, le montant initial de la réservation vous est crédité sous la forme d\'un avoir en ligne, ' + 'que vous pourrez utiliser lors de votre prochaine réservation en ligne.' + '<br><br>' + 'Mit dem <b>Wahltarif</b> (z.B. 5 aus 7 Tagen) erwerben Sie ein Ticket, welches Ihnen die Flexibilität ' + 'vous permet d\'annuler deux jours de votre choix dans la période que vous avez choisie, par exemple en cas de mauvais temps.' },
        SeatReservation: {
          headerText: 'Réservation obligatoire des places',
          modalTitle: 'Qu\'est-ce qu\'une réservation de place assise ?',
          modalContent: 'Les places dans l\'Alpuschnaager sont limitées. Avec une réservation à l\'Alpuschnaager, vous garantissez ' + 'nous vous réservons une place dans l\'Alpuschnaager à la période choisie. Si vous faites une réservation Alpuschnaager ' + 'nous vous prions de vous présenter au plus tard 10 minutes avant l\'aller réservé à l\'Egga ou à la ' + 'de vous présenter à Moosalp pour le retour avec votre billet (Print@Home ou sur votre téléphone portable). Sinon, ' + 'votre réservation Alpuschnaager ne peut pas être garantie.'
        }
      },
      specificModuleComponentLevel: { singleRideMoosalpregion: { Basket: { modalContent: '<b>Adultes</b>: nés en 1999 et avant <br>' + '<b>Jeunes</b>: nés de 2000 à 2004 <br>' + '<b>enfants</b>: nés de 2005 à 2011 <br>' + '<b>Petits enfants</b>: nés en 2012 et plus jeunes <br>' } } }
    },
    niesen: {
      componentLevel: {
        StandardCalendar: {
          headerText: 'Choisissez votre date',
          modalTitle: 'Choisissez votre date',
          modalContent: 'Cliquez sur la date de voyage souhaitée dans le calendrier. Un voyage en train est valable pour une journée.'
        },
        HotelCalendar: {
          headerText: 'Choisissez une date d\'arrivée',
          modalTitle: 'Choisissez une date d\'arrivée',
          modalContent: 'Sélectionnez la date d\'arrivée souhaitée dans le calendrier.'
        }
      }
    },
    // destination independent fallback
    destinationFallback: {
      Basket: { modalTitle: 'Distinctions tarifaires' },
      StandardCalendar: { headerText: 'Choisissez votre date' },
      HotelRoomSelector: { headerText: 'Sélectionnez le type de chambre que vous souhaitez' },
      ContactForm: {
        headerText: 'Demande de groupe',
        modalContent: 'Demande de groupe',
        modalTitle: 'Demande de groupe'
      },
      SendRequest: { headerText: 'Envoyer la demande' },
      SelectMedium: { headerText: 'Personnalisez vos produits' },
      SeatReservation: { modalTitle: 'Qu\'est-ce qu\'une réservation du funiculaire et que dois-je prendre en compte?' },
      SeasonAbos: {
        headerText: 'Informations sur l\'abonnement',
        modalTitle: 'Informations sur l\'abonnement'
      },
      ShopLogin: { headerText: 'Connectez-vous' }
    }
  },
  powerBi: {
    couldNotBeLoaded: 'Les Power BIs n\'ont pas pu être récupérés.',
    couldNotBeSaved: 'Power BI n\'a pas pu être sauvegardé.',
    couldNotBeDeleted: 'Power BI n\'a pas pu être supprimé.',
    urlMustNotBeEmpty: 'L\'URL ne doit pas être vide.',
    selectBi: 'Choisissez votre Power BI'
  },
  stornoHistory: {
    excelDownload: 'Exporter la liste',
    cancellations: 'Annulation',
    voucher: 'Online Balance',
    exportCancellations: 'Export annulation',
    exportVoucher: 'Export Online Balance',
    customer: 'Client',
    cancellationId: 'Résiliation id',
    customerId: 'ID du client',
    customerFirstName: 'Prénom du client',
    customerLastName: 'Nom du client',
    customerMail: 'Courriel du client',
    productName: 'Produit',
    employeeFirstName: 'Prénom de l\'employé',
    employeeLastName: 'Nom de famille de l\'employé',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    priceNet: 'Prix netto',
    priceGross: 'Prix brut',
    mail: 'Courrier électronique',
    reason: 'Reason',
    address: 'Adresse',
    zip: 'ZIP',
    city: 'Ville',
    currency: 'Monnaie',
    balance: 'Online Balance',
    noData: 'Il n\'y a pas de données dans l\'intervalle de temps donné'
  },
  ticketProvider: {
    swisspass: 'Swisspass',
    novatouch: 'Novatouch',
    axess: 'Axess',
    skidata: 'Skidata',
    unknown: 'Inconnu'
  },
  basketConditions: {
    unknownBasketCondition: 'Condition inconnue du panier d\'achat',
    basketConditionsNotMet: 'Veuillez noter les conditions relatives au produit que vous avez choisi.',
    textComposition: {
      min: 'au moins {count}x',
      max: 'au maximum {count}x',
      but: 'mais',
      conditionText: 'Ajoutez "{attributeTitle}" {conditionTexts} au panier.'
    }
  }
};